import _ from 'lodash';
import React, {cloneElement, useContext, useEffect, useMemo, useRef, useState} from 'react';
import {useHistory, useRouteMatch} from 'react-router';
import Modal from 'react-modal';
import localforage from 'localforage';
import postal from 'postal';
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";

import {faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {useAppDispatch, useAppSelector} from './app/hooks';

import JobSwitchingMenu from './components/JobSwitchingMenu';
import JobSwitchingMenuContext, {JobSwitchingMenuState} from './components/jobSwitchingMenuContext';

import ApplicationContext from './ApplicationContext';

import config from './config';
import constants from './constants';
import routes from './config/routes';

import {NavigationType, openNewPage} from './util/navigationHelpers';
import { eawbBrokerType, findSecurityTask, getDetailSecLinkInfo, getJobNamesByCurrentUrl, getListItemByJobName, hasReadableSecurityTask, isEawbEnabled, MenuFilterGrents, stringsEqualIgnoreCase} from './util';

import useGlobalYesNoDialog from './hooks/useGlobalYesNoDialog';
import useGlobalOkDialog from './hooks/useGlobalOkDialog';
import useSystemSettings from './hooks/useSystemSettings';

import ButtonGroup from './uiControls/ButtonGroup';
import OkButton from './uiControls/OkButton';

import IfmsTopBar from './components/IfmsTopBar';
import {IfmsConfigMenuItem} from './config/types';

import NoticeOKIcon from './img/notice_inform_blue.svg';
import NoticeYesNoIcon from './img/notice_inform_YesNo.svg';
import NoticeErrorIcon from './img/notice_error.svg';
import NoticeWarningIcon from './img/notice_warning.svg';
import diamondLightIcon from './img/sidebar-diamond-light.svg';
import diamondDarkIcon from './img/sidebar-diamond-dark.svg';
import diamondLightIcon2 from './img/diamond_light.svg';
import selectedDiamondLightIcon2 from './img/diamond_light_hover.svg';
import bulletLightIcon from './img/sidebar-bullet-light.svg';
import bulletDarkIcon from './img/sidebar-bullet-dark.svg';
import bulletLightIcon2 from './img/circle_light.svg';
import selectedBulletLightIcon2 from './img/circle_light_hover.svg';

import {changeOperation, changeSideMenu, clearOperation} from './features/operationSlice';
import {JobMenuItem, moveJobToOperation, replaceJobMenuMetadata, replaceJobMenuParentOp} from './features/jobMenuSlice';
import { moveScreenToOperation, replaceScreenStackMetadata, replaceScreenUrlParentOpOnStack} from './features/screenStackSlice';
import {logoutUser as logout} from './features/loginSlice';
import {clearStorage} from './features/storageSlice';
import {hideGlobalOkDialog} from './features/globalOkDialogSlice';
import {hideGlobalYesNoDialog} from './features/globalYesNoDialogSlice';
import {hideGlobalYesNoCancelDialog, YesNoCancelResult} from './features/globalYesNoCancelDialogSlice';

import fastStorage from './fastStorage';
import IfmsModal from "./ui/IfmsModal";
import {JobNames, getJobNameByTbName, getJobNameFromInvBillCrdbTbName, getOpByjobName, getOpTypeFromInvBillCrdbTbName, getOpConstant, getOpByName, getTbNameByJobName} from './framework.core/JobNames';
import {clearLastSavedJobs} from './features/lastSavedJobSlice';
import useExternalScreenFilter from './hooks/useExternalScreenFilter';
import useReportViewer from './hooks/useReportViewer';
import {ReportHyperKey} from './fms.report';
import {getListJobNameByJobName} from './components/common/listJobNames';
import { resetListScreenSettings } from './features/listScreenSettingsSlice';
import IfmsSideMenu, { IfmsSideMenuWidth } from './IfmsSideMenu';
import Spinner from './ui/Spinner';
import TableHeaderSizeDisplay from './uiControls/TableHeaderSizeDisplay';
import { FmsSubMenu } from './constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from './components/JobListSubMenu';
import { ApiResult, InsertResultsWithData } from './framework.core/data/ApiResult';
import { getFmsGlobal } from './globals';
import useJobMenuUrlQuery from './hooks/useJobMenuUrlQuery';
import { storageKeyMap } from './hooks/useSetEditedId';

import oceanImportRoutes, { OiHblView, OiMblView } from './components/oceanImport/routes';
import oceanExportRoutes, { OeHblView, OeMblView, OeBookingView } from './components/oceanExport/routes';
import airImportRoutes, { AiHawbView, AiMawbView } from './components/airImport/routes';
import airExportRoutes, { AeHawbView, AeMawbView } from './components/airExport/routes';
import otherShipmentRoutes, { OtherShipmentView } from './components/otherShipment/routes';
import warehousingRotues, { WhReceiptView, WhReceivingView, WhShippingView } from './components/warehousing/routes';
import customerRotues, { CompanyView } from './components/common/routes';
import accountingRotues, { InvoiceView, BillView, CrdbView, GeneralInvoiceView, GeneralBillView } from './components/accounting/routes';

import useFunction from './hooks/useFunction';
import { SearchModelBase } from './fms.data/models/SearchModelBase';
import MyMemo from './components/reports/MyMemo';
import useJobMenus from './hooks/useJobMenus';
import LeftRightSplit from './ui/LeftRightSplit';
import { SQLField, SQLInfo, SQLType } from './framework.core/data/SQLInfo';
import { focusTabableByIndex, getCurrentTabableIndex, getTabableElementByIndex } from './util/inputUtils';
import { ActionButtonItem } from './ui/ActionButton';
import VolumebyCargoTypeYears from './components/reports/VolumebyCargoTypeYears';
import { useJournal } from './components/accounting/general/journal/JournalListView';
import HistoryView from './components/reports/HistoryView';
import PrintBill from './components/accounting/bill/report/PrintBill';
import { DocumentType } from "./framework.core/DocumentType";
import AutoBilling from './components/accounting/gInvoice/AutoBilling/AutoBilling';
import AesUsageReportView from './components/aes/UsageReportView';
import { CFSManifestReleaseOption } from './framework.core/edi/CFSManifestReleaseOption';
import HblReleasePopup from './components/oceanImport/hbl/HblReleasePopup';
import { ReleaseHblInfo } from './fms.data/models/ReleaseHblInfo';
import BankEdi from './components/accounting/payments/billPayment/reports/BankEdi';
import JobListViewContext from './components/common/JobListViewContext';
import { getJobFromName, listViewPagePerBatch, listViewPageSize } from './components/common/JobListView';
import { getInitialSearch } from './filtering';
import { FmsSecAmsTasks, FmsSecTask } from './fms.core/constants';
import { useRunAceFiling } from './components/aceBrowserContext';
import { getSecBySecTask } from './util';
import { SecType, SiteLogType } from './fms.enum';
import { VirtualTableRowHeight } from './ui/tables/Table';
import { useReminderContext } from './ReminderContext';
import { electronMassDependencies } from 'mathjs';
import { GlobalLoadingModal, GlobalLoadingWithMessageModal } from './GlobalLoadingComponents';
import { openCustomerProfitLoadingWindow, renderCustomerProfit } from './components/reports/CustomDashboard/CustomerProfitReport';
import { CustomerProfitByYear, SalesCostByCustomer } from './fms.core/BusinessIntelligenceModel';
import { openTotalSalesCustomerLoadingWindow, renderTotalSalesCustomer5Year } from './components/reports/CustomDashboard/TotalSalesCustomer5Year';
import { renderErrorIntoWindow } from './components/reports/CustomDashboard/CustomDashboardUtils';
import { openTotalSalesCustomerQuarterlyLoadingWindow, renderTotalSalesCustomerQuarterly } from './components/reports/CustomDashboard/TotalSalesCustomerQuarterly';
import { openTotalSalesCustomerMonthlyLoadingWindow, renderTotalSalesCustomerMonthly } from './components/reports/CustomDashboard/TotalSalesCustomerMonthly';
import { openBusinessChartLoadingWindow, renderBusinessChart, splitPeriod } from './components/reports/CustomDashboard/BusinessChart';
import { MonthlyData } from './ui/charts/MonthlyBarChart';
import aiapi, { BACKEND_URL } from './aiapi';
import AIDropZone from './uiControls/aiDropZone/AIDropZone';
import { AI_CENTER_CONTACT_SUPPORT, isAiCenterOff, refreshAiCenterFlags, setAiCenterGrant, setAiTenant } from './aiCenterFlags';
import { ToastContainer, useToasts } from './ui/toast';
import { useSecureNavigate } from './hooks/useSecureNavigate';
import { apiCallResolver } from './api/ifmsApi';
import { getApiKey } from './apiKeyProvider';

// Can be set to true in development mode to allow easy checking of table column sizes (button Show/Hide is displayed in bottom right corner).
const DebugTableHeaderSizes = false;

// Implementation note:
//   Try to get operation from url (if the url starts with '/oceanImport', the operation is Ocean Import)
//  Otherwise, try to use user default operation. If it is also missing, use Ocean Import operation by default
//                                            (2020 10 29) (Dario)
function operationFactory(initializationPath:string|null|undefined, userDefaultOperation:string|null|undefined = null) {
  if (!!initializationPath) {
    const operationsMap = _.map(constants.operations, (value, key) => ({
      key,
      value,
    }));

    const matchFromUrl = operationsMap.find(x => initializationPath.startsWith(`/${x.key}`));

    if (matchFromUrl) {
      return matchFromUrl.value;
    }
  }

  return userDefaultOperation ? userDefaultOperation : constants.operations.oceanImport;
}

const ModalContentStyle:React.CSSProperties = {
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 10000
};

const ModalDialogContentStyle:React.CSSProperties = {
  top: '50%',
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  marginRight: '-50%',
  transform: 'translate(-50%, -50%)',
  border:'1px solid',
  borderRadius:'0px',
  borderColor:'#00F',
  zIndex: 10000,
  paddingLeft:'40px',
  paddingRight:'40px'
};

const ModalOverlayStyle:React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.55)',
  zIndex: 999998
};

let navigationSubscription:ISubscriptionDefinition<any>|null = null;
let ajaxErrorSubscription:ISubscriptionDefinition<any>|null = null;
let ajaxStartSubscription:ISubscriptionDefinition<any>|null = null;
let ajaxEndSubscription:ISubscriptionDefinition<any>|null = null;
let loadingStartSubscription:ISubscriptionDefinition<any>|null = null;
let loadingEndSubscription:ISubscriptionDefinition<any>|null = null;
let viewReportSubscription:ISubscriptionDefinition<any>|null = null;
let tableEditSubscription:ISubscriptionDefinition<any>|null = null;
let broadcastChannel:BroadcastChannel|null = null;  //<pt220314>
let movetologinSubscription:ISubscriptionDefinition<any>|null = null; //<240221.dwshin>

let tooltipElement:HTMLElement|null|SVGElement = null;

function getTooltipPosition(tooltipNode:HTMLElement) {
  if (!tooltipElement) {
    return {left: 0, top: 0};
  }

  const rect = tooltipElement.getBoundingClientRect();
  const rectParent = (tooltipElement as HTMLElement).offsetParent;
   document.body.appendChild(tooltipNode);
  const tRect = tooltipNode.getBoundingClientRect();

  if (rectParent) {
    if (rectParent.getAttribute('role') === 'cell') { // Is special tooltip (INV, BIL, Consignee, Shipper...)
      if(!tooltipElement.dataset.tooltipposition)tooltipElement.dataset.tooltipposition = 'listview-cell';
    }
    else if(rectParent.className === 'ifms-job-btn-container') {
      tooltipElement.dataset.tooltipposition = 'tab-tooltip';
    }
  }
  if (!tooltipElement.dataset.tooltipposition || tooltipElement.dataset.tooltipposition === 'bottom') {
    
    // 수정 전 코드에서 확인 해보니 tRect 값이 0으로 출력 되고 있었음. tRect값을 가져오게 변경했는데 이에 따라 left 위치도 변경 되어 - tRect.width 부분을 삭제 함 
    return { left: rect.left + (rect.width / 2), top:  rect.top - tRect.height  };
    //return { left: (rect.left + rect.width/2 - tRect.width), top: rect.top - rect.height };
  }
  if (tooltipElement.dataset.tooltipposition === 'expresssearch') {
    return { left: (rect.left + rect.width/2), top: rect.top - 20 };
    //return { left: (rect.left + rect.width/2 - tRect.width), top: rect.top - 20 };
  }
  if (tooltipElement.dataset.tooltipposition === 'user-button') {
    return { left: rect.left, top: (rectParent?.clientHeight ?? 0) - rect.height - 34};
  }
  if (tooltipElement.dataset.tooltipposition === 'listview-cell') {
    return { left: (rect.left + (rectParent?.clientWidth ? rectParent?.clientWidth/2 : rectParent?.clientWidth ?? 0) ), top: rect.top - 3 };
  } 
  if (tooltipElement.dataset.tooltipposition === 'view-history-icon') {
    return { left: rect.left, top: rect.top - 30 };
  } 
  if (tooltipElement.dataset.tooltipposition === 'print-icon') {
    return { left: rect.left, top: rect.top - 30 };
  }
  //240805 hykim - 회장님 지시로 Column Header Tooltip 제거
  // if (tooltipElement.dataset.tooltipposition === 'listview-header') {
  //   return { left: (rect.left + rect.width), top: rect.top - rect.height };
  // }
  if (tooltipElement.dataset.tooltipposition === 'left') {
    return { left: rect.left - rect.width * 2, top: rect.top - rect.height };
  }
  if (tooltipElement.dataset.tooltipposition === 'right') {
    return { left: rect.right, top: rect.top - rect.height };
  }
  if (tooltipElement.dataset.tooltipposition === 'tab-tooltip') {
    return { left: (rect.left + rect.width / 2 ), top: rect.top - rect.height };
  }

  return { left: (rect.left + rect.width / 2 - tRect.width / 2), top: rect.top - rect.height };
}

function createFragment(htmlStr:string) {
  const frag = document.createDocumentFragment();
  const temp = document.createElement('div');

  temp.innerHTML = htmlStr;

  while (temp.firstChild) {
    frag.appendChild(temp.firstChild);
  }

  return frag;
}

function FindOpendOperationView(currentUrl: string) {
  const resultArray: {
    isOpenOperationView: boolean,
    jobName: JobNames,
    jobParams: any
  }[] = [];

  const normalizeOperationUrl = (url?: string) => {
    if (!url) return '';
    let pureUrl = url.split('?')[0];  

    const parts = pureUrl.split('/').filter(Boolean);

    const normalizedParts = parts.slice(0, 4);    // Operation은 route의 id까지만 url을 가져와서 비교한다.

    return '/' + normalizedParts.join('/');
  };

  const isOpenView = (
    currentUrl: string,
    routeUrl?: string,
    useNormalize: boolean = true
  ) => {
    if (!routeUrl) return false;
    if (!useNormalize) return routeUrl === currentUrl;
  
    return normalizeOperationUrl(currentUrl) === normalizeOperationUrl(routeUrl);
  };

  let routePath = '';
  let routeData: any;

  // Ocean Import 
  routePath = oceanImportRoutes.find(x => x.component === OiMblView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.OIMbl,
    jobParams: routeData?.params
  });

  routePath = oceanImportRoutes.find(x => x.component === OiHblView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.OIHbl,
    jobParams: routeData?.params
  });

  // Ocean Export
  routePath = oceanExportRoutes.find(x => x.component === OeMblView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.OEMbl,
    jobParams: routeData?.params
  });

  routePath = oceanExportRoutes.find(x => x.component === OeHblView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.OEHbl,
    jobParams: routeData?.params
  });

  routePath = oceanExportRoutes.find(x => x.component === OeBookingView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.OEBook,
    jobParams: routeData?.params
  });

  // Air Import
  routePath = airImportRoutes.find(x => x.component === AiMawbView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.AIMbl,
    jobParams: routeData?.params
  });

  routePath = airImportRoutes.find(x => x.component === AiHawbView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.AIHbl,
    jobParams: routeData?.params
  });

  // Air Export
  routePath = airExportRoutes.find(x => x.component === AeMawbView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.AEMbl,
    jobParams: routeData?.params
  });

  routePath = airExportRoutes.find(x => x.component === AeHawbView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.AEHbl,
    jobParams: routeData?.params
  });

  // Other Shipment
  routePath = otherShipmentRoutes.find(x => x.component === OtherShipmentView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.OtherOP,
    jobParams: routeData?.params
  });

  // Warehousing
  routePath = warehousingRotues.find(x => x.component === WhReceiptView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.WHRcpt,
    jobParams: routeData?.params
  });

  routePath = warehousingRotues.find(x => x.component === WhReceivingView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.WHRcv,
    jobParams: routeData?.params
  });

  routePath = warehousingRotues.find(x => x.component === WhShippingView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.WHShip,
    jobParams: routeData?.params
  });

  // Customer
  routePath = customerRotues.find(x => x.component === CompanyView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, true),
    jobName: JobNames.Company,
    jobParams: routeData?.params
  });

  // Accounting
  routePath = accountingRotues.find(x => x.component === InvoiceView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, false),
    jobName: JobNames.Invoice,
    jobParams: routeData?.params
  });

  routePath = accountingRotues.find(x => x.component === BillView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, false),
    jobName: JobNames.Bill,
    jobParams: routeData?.params
  });

  routePath = accountingRotues.find(x => x.component === CrdbView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, false),
    jobName: JobNames.CrDb,
    jobParams: routeData?.params
  });

  routePath = accountingRotues.find(x => x.component === GeneralInvoiceView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, false),
    jobName: JobNames.GInvo,
    jobParams: routeData?.params
  });

  routePath = accountingRotues.find(x => x.component === GeneralBillView)?.path ?? '';
  routeData = useRouteMatch(routePath);
  resultArray.push({
    isOpenOperationView: isOpenView(currentUrl, routeData?.url, false),
    jobName: JobNames.GBill,
    jobParams: routeData?.params
  });
  
  return resultArray.find(x => x.isOpenOperationView);
}

function IfmsMain() {
  const history = useHistory();
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);

  const systemSettings = useSystemSettings();

  const [jobMenuContextState, setJobMenuContextState] = useState<JobSwitchingMenuState>({});

  const {setFilterForScreenExternally} = useExternalScreenFilter();

  const userLogin = useAppSelector(state => state.user);
  const operationState = useAppSelector(state => state.operation);
  const selectedOperation = operationState.operation;

  const globalYesNoCancelDialog = useAppSelector(state => state.globalYesNoCancelDialog);
  const globalYesNoDialog = useAppSelector(state => state.globalYesNoDialog);
  const globalOkDialog = useAppSelector(state => state.globalOkDialog);
  //<pt220928: portal>
  // const globalInputDialog = useAppSelector(state => state.globalInputDialog);

  const jobMenu = useAppSelector(x => x.jobMenu);
  const {cleanupAll, moveToSingleOpenedScreenInAnyOperationStartingWithUrl} = useJobMenus();
  const {switchJournal} = useJournal();
  
  const dispatch = useAppDispatch();

  const [focusEleAfterModalOkBtnClick, setFocusEleAfterModalOkBtnClick] = useState<HTMLElement | null>(null);

  const [initialized, setInitialized] = useState(false);

  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<IfmsConfigMenuItem|null>(null);
  const [selectedReportMenuItem, setSelectedReportMenuItem] = useState<IfmsConfigMenuItem|null>(null);
  const [selectedReportPopupMenuItem, setSelectedReportPopupMenuItem] = useState<ActionButtonItem | null>(null);

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const [showGlobalDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();

  // const reportRef = useRef<ReportViewerHandle>(null);

  // auto logout.
  const autoLogoutTimerId = useRef(-1);
  const autoLogoutRemainTimerId = useRef(-1);
  const isStayLoggin = useRef(false);
  const [autoLogoutCheck, setAutoLogoutCheck] = useState<boolean>(false);
  const [autoLogoutRemain, setAutoLogoutRemain] = useState(600); 

  const currentUrl = `${history.location.pathname}${history.location.search}`;
  const currentListJobName = getJobNamesByCurrentUrl(storageKeyMap, currentUrl);
  const currentListItemModel = getListItemByJobName(currentListJobName);
  const defaultUrls = ['/home/home', '/home', '/'];

  const [isHome, setIsHome] = useState(defaultUrls.includes(currentUrl));
  const isHomeRef = useRef(defaultUrls.includes(currentUrl));
  const activeUrlRef = useRef(currentUrl);
  // 마지막으로 More Menu 를 보여준 Job (Batch Print 화면에서 직전 Job 의 More Menu 를 유지하는 데 쓴다)
  const lastMoreMenuJobNameRef = useRef<JobNames | undefined>(undefined);
  const opendOperationData = FindOpendOperationView(currentUrl);

  const channel = postal.channel('ajax');
  const filterChannel = postal.channel('ifms-filter');
  const { stopRemindTimer } = useReminderContext();
  const { toasts, push, dismiss } = useToasts();

  const setShowReminderOpen = (isOpen: boolean) => {
    appContext.setShowReminderPop((prev: any) =>({
      ...prev,
      isOpen,
    }));
  };

  // let storageName = '';
  // const tableElement = document.querySelectorAll('[class*=ifms-table-content]');
  // if (tableElement.length > 0) storageName = tableElement[0].id
  //const [listSelectedId] = useStorage(storageName, null);
  const listSelectedId = document.getElementById('last-selectedId')?.innerText ?? '';
  const topBarHeight = (document.getElementById('ifms-top-bar')?.offsetHeight ?? 0) - 1;
  const listData = fastStorage[`ifms-list-data-${currentUrl}`]
  const fmsGlobal = getFmsGlobal();
  const hasOpenedScreenStartingWithUrl = useJobMenuUrlQuery();

const menus = useMemo(() => {
    const menus = _.cloneDeep(config.menus.find(x => x.operation === operationState.sideMenu));
    if (!menus || !menus.job) return menus;
 
    const securityGrants = appContext.securityGrants;
    // securityTaskCode filter
    menus.job = MenuFilterGrents(menus.job, securityGrants, appContext);
 
    if(menus.moreMenu && menus.moreMenu.length > 0) menus.moreMenu = MenuFilterGrents(menus.moreMenu, securityGrants, appContext);
    if(menus.operationReport && menus.operationReport.length > 0) menus.operationReport = MenuFilterGrents(menus.operationReport, securityGrants, appContext);
    if(menus.preReport && menus.preReport.length > 0) menus.preReport = MenuFilterGrents(menus.preReport, securityGrants, appContext);
    if(menus.report && menus.report.length > 0) menus.report = MenuFilterGrents(menus.report, securityGrants, appContext);
 
    // menus.moreMenu = 지금 선택/열람 중인 Job 의 컨텍스트 메뉴
    //  - level 1 + moreMenuJobName          : 컨텍스트 메뉴 (Arrival Notice, Print ...)
    //  - level 0 + items + moreMenuJobName  : 컨텍스트 그룹 (Batch Print)
    //
    // 넣는 위치
    //  - job 에 moreMenuSlot 자리표시가 있는 오퍼레이션 (Billings, Warehousing):
    //      같은 moreMenuJobName 을 가진 부모 메뉴가 있으면 그 아래 More Menu 그룹으로,
    //      없으면 자리표시 위치에 평평하게. 정렬하지 않고 config 순서 그대로.
    //  - 그 외: 현재 화면의 부모 메뉴 아래 More Menu 그룹으로. 이름순 정렬.
 
    // 자리표시는 화면에 그리지 않으므로 위치만 기억하고 항상 뺀다
    const moreMenuSlotIndex = menus.job.findIndex(x => x.metadata?.moreMenuSlot);
    if (moreMenuSlotIndex !== -1) menus.job.splice(moreMenuSlotIndex, 1);
 
    if (menus.moreMenu) {
      // 레코드와 무관하게 화면을 바로 여는 메뉴 (링크에 @jobName / @jobid 가 없다): Batch Print, Batch Print History
      const isScreenMenu = (x: IfmsConfigMenuItem) => !!x.link && !x.link.includes('@');
      // 그 메뉴의 화면이 지금 열려 있는지 ('/add' 로 끝나는 링크는 같은 화면의 view 주소도 포함, ?parentOp 등 쿼리는 빼고 비교)
      const isScreenMenuOpened = (x: IfmsConfigMenuItem) => {
        if (!isScreenMenu(x)) return false;
        const path = (x.link ?? '').split('?')[0];
        const baseLink = path.endsWith('/add') ? path.slice(0, -4) : path;
        return currentUrl.startsWith(baseLink);
      };

      // 지금 화면(리스트 / More 탭 / 상세화면)의 Job 을 기억해 둔다
      const activeMoreMenuJobName = menus.moreMenu.find(x => x.moreMenuJobName && CheckMoreMenuJobName(x.moreMenuJobName))?.moreMenuJobName;
      if (activeMoreMenuJobName) lastMoreMenuJobNameRef.current = activeMoreMenuJobName;

      // Batch Print 화면(add / view / History 리스트)에서는 그 화면을 연 Job 의 More Menu 를 그대로 보여준다.
      //  - 직전 Job 에 지금 열린 화면 메뉴가 있으면 그 Job
      //  - 없으면 (새로고침 등) 지금 열린 화면 메뉴를 가진 첫 Job
      const screenOwnerJobNames = menus.moreMenu.filter(isScreenMenuOpened).map(x => x.moreMenuJobName);
      const keptMoreMenuJobName = !activeMoreMenuJobName && screenOwnerJobNames.length > 0
        ? (screenOwnerJobNames.includes(lastMoreMenuJobNameRef.current) ? lastMoreMenuJobNameRef.current : screenOwnerJobNames[0])
        : undefined;

      // ---------- 1. 지금 화면에 해당하는 항목만 남긴다 ----------
      let moreMenuList = menus.moreMenu.filter(x =>
        CheckMoreMenuJobName(x.moreMenuJobName)
        || (!!keptMoreMenuJobName && x.moreMenuJobName === keptMoreMenuJobName)
      );

      moreMenuList.forEach(x => x.metadata = {
        ...x.metadata,
        operationMode: opendOperationData?.jobParams?.mode
      });

      // 유지한 More Menu 중 선택된 레코드가 필요한 항목(Delete History, Print ...)은
      // 이 화면에 레코드가 없어 동작할 수 없으므로 눌러도 반응하지 않게 한다 (모양은 그대로, 화면 메뉴는 그대로 동작)
      if (keptMoreMenuJobName) {
        moreMenuList.forEach(x => {
          if (!isScreenMenu(x)) x.metadata = { ...x.metadata, noClick: true };
        });
        // job 에 항상 있는 View History 도 선택된 레코드 대상이라 함께 막는다
        menus.job.forEach(x => {
          if (x.subMenuNonReport === FmsSubMenu.OpenHistoryView) x.metadata = { ...x.metadata, noClick: true };
        });
      }
 
      if (moreMenuSlotIndex === -1) {
        moreMenuList.sort((a, b) => String(a.text).toUpperCase().localeCompare(String(b.text).toUpperCase()));
      }
 
      if (moreMenuList.length > 0) {
        // ---------- 2. 옵션에 따라 숨기는 항목 ----------
        // 리스트 / More 탭 / 상세화면 모두 여기서 처리한다.
        const isActiveJob = (jobName: JobNames) =>
          currentUrl === storageKeyMap.get(jobName)
          || history.location.search.includes(`jobname=${jobName}`)
          || opendOperationData?.jobName === jobName
          || keptMoreMenuJobName === jobName;
        const hide = (pred: (x: IfmsConfigMenuItem) => boolean) => {
          moreMenuList = moreMenuList.filter(x => !pred(x));
        };
        const hideProfit = fmsGlobal.NoProfitShow ?? false;
        const hideCbp = fmsGlobal.AcmeID === 'BWGR003137';
        const hideStGeorge = !appContext.suntekSettings?.edi?.ediForStGeorgeWarehouse;
        const changeTitleInAnMenu = !!systemSettings?.bl?.changeTitleInAnMenu;
        // Arrival Notice 는 링크 화면용 / 리포트용 2개가 있고 설정에 따라 하나만 남긴다
        const hideArrivalNotice = () => hide(x => x.text === 'Arrival Notice' && (changeTitleInAnMenu ? !x.link : !!x.link));
 
        switch (menus.operation) {
          case 'Ocean Import':
            if (CheckMoreMenuJobName(JobNames.OIMbl)) {
              if (hideStGeorge) hide(x => x.text === 'CFS Manifest');
              if (hideProfit) hide(x => x.text === 'Profit Report');
              if (hideCbp) hide(x => x.text === 'CBP Status Query');
            } else if (isActiveJob(JobNames.OIHbl)) {
              if (hideStGeorge) hide(x => x.text === 'CFS Release');
              hideArrivalNotice();
              if (hideProfit) hide(x => x.text === 'Profit Report');
              if (hideCbp) hide(x => x.text === 'CBP Status Query');
            }
            break;
          case 'Ocean Export':
            if (isActiveJob(JobNames.OEMbl) || isActiveJob(JobNames.OEHbl)) {
              if (hideProfit) hide(x => x.text === 'Profit Report');
            }
            break;
          case 'Air Import':
            if (isActiveJob(JobNames.AIHbl)) {
              hideArrivalNotice();
              if (hideProfit) hide(x => x.text === 'Profit Report');
              if (hideCbp) hide(x => x.text === 'CBP Status Query');
            } else if (isActiveJob(JobNames.AIMbl)) {
              if (hideProfit) hide(x => x.text === 'Profit Report');
              if (hideCbp) hide(x => x.text === 'CBP Status Query');
            }
            break;
          case 'Air Export':
            if (isActiveJob(JobNames.AEHbl) || isActiveJob(JobNames.AEMbl)) {
              if (hideProfit) hide(x => x.text === 'Profit Report');
            }
            break;
          case 'Other Shipment':
            if (isActiveJob(JobNames.OtherOP)) {
              if (hideProfit) hide(x => x.text === 'Profit Report');
              if (hideCbp) hide(x => x.text === 'CBP Status Query');
            }
            break;
          case 'Billings':
            if (isActiveJob(JobNames.GInvo)) {
              const suntekId = appContext.suntekSettings?.company?.companyId?.toUpperCase() ?? '';
              if (suntekId !== 'FSSUNTEK' && suntekId !== 'IFMSSUNTEK') hide(x => x.text === 'Auto Billing');
            }
            break;
        }
 
        // ---------- 3. 사이드 메뉴(job)에 끼워 넣기 ----------
        if (moreMenuList.length > 0) {
          const moreMenuGroup = (items: IfmsConfigMenuItem[]): IfmsConfigMenuItem =>
            ({ text: 'More Menu', level: 0, items, metadata: { hideMenu: true } });
 
          if (moreMenuSlotIndex !== -1) {
            // Billings, Warehousing
            const parentJobNames = menus.job.filter(x => x.moreMenuJobName).map(x => x.moreMenuJobName);
            const slotItems = moreMenuList.filter(x => !parentJobNames.includes(x.moreMenuJobName));
            const childItems = moreMenuList.filter(x => parentJobNames.includes(x.moreMenuJobName));
 
            // 부모 메뉴가 없는 Job (Invoice/Bill/CrDb 등): 자리표시 위치에 평평하게
            menus.job.splice(moreMenuSlotIndex, 0, ...slotItems);
 
            // 부모 메뉴가 있는 Job (창고 Receiving/Shipping): 부모 아래 More Menu 그룹으로
            if (childItems.length > 0) {
              const parentIndex = menus.job.findIndex(x => x.moreMenuJobName === childItems[0].moreMenuJobName);
              menus.job.splice(parentIndex + 1, 0, moreMenuGroup(childItems));
            }
          } else {
            // 부모 메뉴 찾기: 현재 리스트 화면 → URL 의 jobname(More 탭) → 열린 상세화면
            let insertIndex = -1;
            const listMenuIndex = menus.job.findIndex(x => x.link?.includes(currentUrl));
            if (listMenuIndex !== -1) {
              insertIndex = listMenuIndex + 1;
            } else if (currentUrl.includes('jobname=')) {
              const jobName = GetMoreMenuJobName(currentUrl);
              const parentIndex = menus.job.findIndex(x => x.moreMenuJobName?.includes(jobName));
              if (parentIndex !== -1) insertIndex = parentIndex + 1;
            } else if (opendOperationData?.jobName) {
              // 기존 동작: 못 찾으면 맨 위(0)에 들어간다
              insertIndex = menus.job.findIndex(x => x.moreMenuJobName === opendOperationData?.jobName) + 1;
            }
 
            if (insertIndex !== -1) {
              menus.job.splice(insertIndex, 0, moreMenuGroup(moreMenuList));
            }
          }
        }
      }
 
      // 필요한 항목은 위에서 job 에 끼워 넣었으므로 항상 비운다.
      menus.moreMenu = [];
    }
 
    if (menus.operation === constants.operations.utility) {
      menus.job =
        menus.job.map(job => {
          const tempData = String(job.text).includes('B/L Activity Status');
          if (tempData) {
            if (String(job.text).includes('OIH')) {
              job.text = appContext.systemSettings?.showMilestoneInOihList ? 'OIH B/L Activity Status Off' : 'OIH B/L Activity Status On'
            } else {
              job.text = appContext.systemSettings?.showMilestoneInAihList ? 'AIH B/L Activity Status Off' : 'AIH B/L Activity Status On'
            }
          }
          return { ...job };
        });
    }
 
    if (menus.operation === constants.operations.opReport) {
      menus.job =
        menus.job.map(job => {
          const tempData = String(job.text).includes('Branch Performance');
          if (tempData) {
            job.text = appContext.suntekSettings?.company?.enableBranch ? 'Branch Performance' : 'Performance'
          }
          return { ...job };
        });
    }
 
    // 250203 jhchoi : #1895 - Payroll (Old) 데이터가 있는 경우에만 Payroll(Old) Menu를 표시(notShowOldPayroll 값은 Fix Query를 통해 설정된다.)
    if (menus.operation === constants.operations.accounting) {
      //suntekKor인 경우 Journal List의 하위메뉴가 추가되어야 하여 Journal List 메뉴 변경 필요
      const suntekKor = appContext.suntekSettings?.company?.suntekKor;
      if(suntekKor){
        menus.job = menus.job.filter(x => !(x.metadata?.suntekKor === false));
      }
      else {
        menus.job = menus.job.filter(x => !(x.metadata?.suntekKor === true));
      }
    }

    //Shipment Control Tower > Report Scheduling, Report History Menu는 Suntek Setting 옵션에 따라 메뉴 표시
    if (menus.operation === constants.operations.shipmentStatus) {
        const useReportScheduling = appContext.suntekSettings?.general?.useReportScheduling ?? false;
        if (!useReportScheduling) menus.job = menus.job.filter(x => x.text !== 'Report Scheduling' && x.text !== 'Report History');
    }

    //fssuntek인 경우만 Accounting Classify >  Advance Sales 하위메뉴가 표시되도록 추가

    let suntekId = appContext.suntekSettings?.company?.companyId?.toUpperCase() ?? '';

    if (suntekId != 'FSSUNTEK' && suntekId != 'IFMSSUNTEK') {
        menus.job = menus.job = menus.job.map(x => ({ ...x, items: x.items?.filter(item => item.text !== 'Advance Sales') }));
    }
 
    return menus;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    operationState.sideMenu,
    currentUrl,
    appContext.securityGrants,
    appContext.user,
    appContext.suntekSettings,
    appContext.systemSettings,
    systemSettings,
    fmsGlobal.NoProfitShow,
    fmsGlobal.AcmeID,
  ]);

  const runAceFiling = useRunAceFiling();

  const getExternalFunctions = useFunction({
    callbacks: ['ifmsSettingsSave', 'ifmsSettingsCancel','ifmsReferenceFilesSave', 'ifmsReferenceFilesCancel', /*'ifmsMyTaskSave', 'ifmsMyTaskCancel'*/]
  });


  //const _isRunning = useRef<boolean>(false);
  //const TaskReminderTimer = 60000;
  
  const marginWidth = isHome ? '0px' : IfmsSideMenuWidth;

  function resetJobMenuContextState() {
    setJobMenuContextState({});
  }

  function setInJobMenuContext(key: string, value: any) {
    const newJobMenuContextState = _.cloneDeep(jobMenuContextState);
    newJobMenuContextState[key] = value;  

    setJobMenuContextState(newJobMenuContextState);
  }

  const setSelectedOperation = (data:string) => {
    dispatch(changeOperation(data));
  };

  const {viewReport, viewEmptyReport} = useReportViewer();   // optab-rptviewer
  const { getSingleOpenedScreenInAnyOperationStartingWithUrl } = useJobMenus();
  const darkModeRef = useRef(appContext.useDarkMode);

  // Report > HyperLink를 통해 동일한 항목을 반복해서 클릭하는 경우 리스트가 갱신되지 않아 항목이 사라지는 문제를 해결하기 위해 추가
  const versionCount = useRef<number>(1);   
  
  const secureNavigate = useSecureNavigate();
  //Toast Msg > Link Navigate
  async function onNavigate(entity: any){
    if (!entity) return null;  //entity.meta
    if(!entity.jobId) return null;
    if (entity.jobName === JobNames.ISF) {
      try {
        const apiResult = await appContext.api.getIsfLink('', entity.jobId, entity.isfType);
        if (apiResult && apiResult.success) {
          //apiResult.result.item2 : auto Login 여부 (1 : true, 0: false)
          if(!appContext.user?.isSuntekAdmin) await appContext.api.saveSiteAccessLog(SiteLogType.IsfWeb, apiResult.result.item2 ? 1 : 0);
            window.open('https://imanifest.suntekscm.com/Home/AutoLoginFms?args=' + apiResult.result.item1);
          //window.open('https://imantest.suntekscm.co.kr/Home/AutoLoginFms?args=' + apiResult.result.item1); // Test
          // window.open('http://localhost:4649/Home/AutoLoginFms?args=' + apiResult.result.item1); // Debug
        }
      } catch (error) {
        console.error('ISF Detail Error:', error);
      }
    }
    else {
      // 링크가 떠 있는 동안 본인·타인이 레코드를 지웠을 수 있다 — AI Center Review 열과 같이 이동 전에 존재를 확인하고,
      // 없으면 화면이 깨지는 대신 안내만 띄운다 (2026-09-23 hykim). 확인 자체가 실패하면 종전처럼 이동을 시도한다.
      try {
        const exists = await appContext.api.existListId(entity.jobId, entity.jobName);
        if (exists === false) {
          await showGlobalOkDialog(<p>The record could not be found. It may have been deleted.</p>);
          return;
        }
      } catch (error) {
        console.error('existListId check failed:', error);
      }

      const {secTask, detailUrl } = getDetailSecLinkInfo(entity.jobName, entity.jobId,  entity.parentJobId, getTbNameByJobName(entity.parentJobName));
      if(!secTask || !detailUrl) return;
        secureNavigate(secTask, () =>
          moveToSingleOpenedScreenInAnyOperationStartingWithUrl(detailUrl, [detailUrl, detailUrl.replace('/view', '/edit')])
        );
    }
  }

  async function bcMessageHandler(e: any) {
    const args = decodeURIComponent(e.data.Target).split('^');
    let jobName, jobId, apiResult, opType, parentOp, jobTaskSec, orderBy ='';
    const windowName = `ifmsmain-${appContext.user?.suntekId?.toLowerCase()}-${appContext.user?.id?.toLowerCase()}`;
    
    if (args[0] === 'CloseWindow') {
      if (window.name.indexOf('ifmssub') > -1) window.close();
      return;
    } else if (args[0] === 'MoveToLogin') {
      broadcastChannel?.postMessage({ Target: 'CloseWindow' });
      channel.publish('ajax.movetologin', {});
      return;
    } else if (args[0] === 'OpenOperationDetail') {
      switch (args[1].toUpperCase()) {
        case 'OIM':
          jobName = JobNames.OIMbl; jobId = args[2]; opType = constants.opTypes.oceanImport; jobTaskSec = FmsSecTask.OIMbl; orderBy ='u2Date'; break;
        case 'OIH':
          jobName = JobNames.OIHbl; jobId = args[2]; opType = constants.opTypes.oceanImport; jobTaskSec = FmsSecTask.OIHbl; orderBy ='u2Date'; break;
        case 'OOM':
        case 'OEM':
          jobName = JobNames.OEMbl; jobId = args[2]; opType = constants.opTypes.oceanExport; jobTaskSec = FmsSecTask.OEMbl; orderBy ='u2Date'; break;
        case 'OOH':
        case 'OEH':
          jobName = JobNames.OEHbl; jobId = args[2]; opType = constants.opTypes.oceanExport; jobTaskSec = FmsSecTask.OEHbl; orderBy ='u2Date'; break;
        case 'AIM':
          jobName = JobNames.AIMbl; jobId = args[2]; opType = constants.opTypes.airImport; jobTaskSec = FmsSecTask.AIMbl; orderBy ='u2Date'; break;
        case 'AIH':
          jobName = JobNames.AIHbl; jobId = args[2]; opType = constants.opTypes.airImport; jobTaskSec = FmsSecTask.AIHbl; orderBy ='u2Date'; break;
        case "AOM":
        case "AEM":
          jobName = JobNames.AEMbl; jobId = args[2]; opType = constants.opTypes.airExport; jobTaskSec = FmsSecTask.AEMbl; orderBy ='u2Date'; break;
        case "AOH":
        case "AEH":
          jobName = JobNames.AEHbl; jobId = args[2]; opType = constants.opTypes.airExport; jobTaskSec = FmsSecTask.AEHbl; orderBy ='u2Date'; break;
        case "OTH":
          jobName = JobNames.OtherOP; jobId = args[2]; opType = constants.opTypes.otherShipment; jobTaskSec = FmsSecTask.OtherOP; orderBy ='u2Date'; break;
        case "WHR":
          jobName = JobNames.WHRcv; jobId = args[2]; opType = constants.opTypes.warehousing; jobTaskSec = FmsSecTask.WHRcv; orderBy ='u2Date'; break;
        case "WHS":
          jobName = JobNames.WHShip; jobId = args[2]; opType = constants.opTypes.warehousing; jobTaskSec = FmsSecTask.WHShip; orderBy ='u2Date'; break;
        case "T_INVOHD":
          apiResult = await appContext.api.getSourceJobInfo(JobNames.Invoice, args[2]);
          if (apiResult && apiResult.success && apiResult.result) {
            jobId = args[2];
            jobName = JobNames.Invoice;
            jobTaskSec = FmsSecTask.AcctInvoiceList; 
            orderBy ='u2Date'; 
            switch (apiResult.result.tbName.toUpperCase()) {
              case "T_STORAGE":
                jobName = JobNames.WHStorageInv;
                opType = constants.opTypes.warehousing;
                jobTaskSec = FmsSecTask.WHStorageInv; 
                break;
              case "T_WRECEIVE":
              case "T_WRECEIVEHD":
              case "T_WSHIPHD":
              case "T_WHPERIOD":
                opType = constants.opTypes.warehousing;
                jobTaskSec = FmsSecTask.WHInvoice; 
                break;
              default:
                if (apiResult.result.tbId === 0) {
                  jobName = JobNames.GInvo;
                  jobTaskSec = FmsSecTask.AcctGInvoList; 
                }
                opType = constants.opTypes.accounting;
                break;
            }
          }
          break;
        case "T_APHD":
          apiResult = await appContext.api.getSourceJobInfo(JobNames.Bill, args[2]);
          if (apiResult && apiResult.success && apiResult.result) {
            jobId = args[2];
            jobName = JobNames.Bill;
            jobTaskSec = FmsSecTask.AcctBillList; 
            orderBy ='updatedDate'; 
            switch (apiResult.result.tbName.toUpperCase()) {
              case "T_WRECEIVE":
              case "T_WRECEIVEHD":
              case "T_WSHIPHD":
                opType = constants.opTypes.warehousing;
                jobTaskSec = FmsSecTask.WHBill; 
                break;
              default:
                if (apiResult.result.tbId === 0) {
                  jobName = JobNames.GBill;
                  jobTaskSec = FmsSecTask.AcctGBillList; 
                }
                opType = constants.opTypes.accounting;
                break;
            }
          }
          break;
        case "T_CRDBHD":
          apiResult = await appContext.api.getSourceJobInfo(JobNames.CrDb, args[2]);

          if (apiResult && apiResult.success && apiResult.result) {
            jobId = args[2];
            jobName = JobNames.CrDb;
            jobTaskSec = FmsSecTask.AcctCrDbList; 
            orderBy ='u2Date'; 
            switch (apiResult.result.tbName.toUpperCase()) {
              case "T_WRECEIVE":
              case "T_WRECEIVEHD":
              case "T_WSHIPHD":
              case "T_WHPERIOD":
                opType = constants.opTypes.warehousing;
                jobTaskSec = FmsSecTask.WHCrDb; 
                break;
              default:
                opType = constants.opTypes.accounting;
                break;
            }
          }
          break;
        case "T_DEPOHD":
          jobId = args[2];
          orderBy ='u2Date'; 
          if (args[4] === "D") {
            jobName = JobNames.CustPayment;
            jobTaskSec = FmsSecTask.AcctCustPayment; 
          }
          else if (args[4] === "M") {
            jobName = JobNames.CCPayment;
            jobTaskSec = FmsSecTask.AcctCCPayment; 
          }
          else {
            jobName = JobNames.BillPayment;
            jobTaskSec = FmsSecTask.AcctBillPayment; 
          }
          opType = constants.opTypes.accounting;
          break;
        case "PAY": jobName = JobNames.PayrollSummary; jobId = args[2]; opType = constants.opTypes.accounting; jobTaskSec = FmsSecTask.AcctPayroll; orderBy ='modifiedAt'; break;
        case "PAY2": jobName = JobNames.Payroll2; jobId = args[2]; opType = constants.opTypes.accounting; jobTaskSec = FmsSecTask.AcctPayroll; orderBy ='modifiedAt'; break;
      }

      if (!!jobTaskSec && jobName) {
        const jobGrant = findSecurityTask(appContext, jobTaskSec as FmsSecTask);
        if (jobGrant.grantRead) {
          // <dario> - Example how to open list screen with filtering. This example opens invoice list view
          //const invoiceNo = 'INV-18931';
          let listUrl = `/common/joblistview/${getListJobNameByJobName(jobName)}/${opType}`;

          // find all screen stack - url screen opened.
          const lastScreenQuery = getSingleOpenedScreenInAnyOperationStartingWithUrl(listUrl);
          let lastScreen;
          if (lastScreenQuery && lastScreenQuery.item) {
            lastScreen = lastScreenQuery.item;
            listUrl = lastScreen.url;
            parentOp = listUrl?.split("parentOp=")[1];
          } else if (
            (args[1].toUpperCase() === "T_INVOHD" ||
              args[1].toUpperCase() === "T_APHD" ||
              args[1].toUpperCase() === "T_CRDBHD") && opType !== constants.opTypes.warehousing
          ) {
            listUrl = `${listUrl}?parentOp=billings`
          }

          setFilterForScreenExternally(
            listUrl,
            'id', // filter property name in model
            '', // property label, can be omitted as ''
            jobId?.toString() ?? '', // Filter value
            orderBy, // order by column in model
            false,    // orderByAscending
            true,     // startWithEntry
            ({ ...new SearchModelBase(), version: versionCount.current } as SearchModelBase)  // Update version
          );
          versionCount.current += 1;

          if (lastScreen) {
            openNewPage(history, listUrl, NavigationType.jobMenuSwitch, lastScreen.metadata, parentOp);
          } else {
            openNewPage(history, listUrl, NavigationType.newPage);
          }
        } else {
          openNewPage(history, '/home/home', NavigationType.newPage);
          showGlobalOkDialog(<p>Please check your user security!!!</p>);
        }
      } else {
        //Detail View OPen
        let link = '';
        if (args[1].toUpperCase() === 'CUSTOMERPAY') {
          link = `/accounting/acCustomerPayment/`;
          jobTaskSec = FmsSecTask.AcctCustPayment; 
        }
        else if (args[1].toUpperCase() === 'BILLPAY') {
          link = `/accounting/acBillPayment/`;
          jobTaskSec = FmsSecTask.AcctBillPayment; 
        }
        else if (args[1].toUpperCase() === 'AGENTSUMMARY') {
          if (+args[3] < 0) {
            link = `/accounting/acBillPayment/`;
            jobTaskSec = FmsSecTask.AcctBillPayment; 
          } else {
            link = `/accounting/acCustomerPayment/`;
            jobTaskSec = FmsSecTask.AcctCustPayment; 
          }
        }

        if (!!jobTaskSec) {
          const jobGrant = findSecurityTask(appContext, jobTaskSec as FmsSecTask);
          if (jobGrant.grantRead) {
            // Agent/Customer/Vendor Outstanding Report에서 New Customer,Bill Pay가 여러개가 뜨도록 변경
            // home으로 한 번 이동 후 New Pay가 표시되어야 제대로 동작됨
            // if (hasOpenedScreenStartingWithUrl(link)) {
            //   await showGlobalOkDialog(<p>Payment Operation is already in progress</p>);
            //   return;
            // }else
            openNewPage(history, '/home/home', NavigationType.newPage);
            openNewPage(history, `${link}add/${args[2]}`, NavigationType.newPage);
          } else {
            openNewPage(history, '/home/home', NavigationType.newPage);
            showGlobalOkDialog(<p>Please check your user security!!!</p>);
          }
        }
      }
    } else if (args[0] === 'CompanySalesSummaryLink') {
      let model = new SearchModelBase();
      jobName = JobNames.OIMbl;

      switch (args[1]) {
        case "T_OIMMAIN":
          jobName = JobNames.OIMbl;
          opType = constants.opTypes.oceanImport;
          jobTaskSec = FmsSecTask.OIMbl; 
          break;
        case "T_OIHMAIN":
          jobName = JobNames.OIHbl;
          opType = constants.opTypes.oceanImport;
          jobTaskSec = FmsSecTask.OIHbl; 
          break;
        case "T_OOMMAIN":
          jobName = JobNames.OEMbl;
          opType = constants.opTypes.oceanExport;
          jobTaskSec = FmsSecTask.OEMbl; 
          break;
        case "T_OOHMAIN":
          jobName = JobNames.OEHbl;
          opType = constants.opTypes.oceanExport;
          jobTaskSec = FmsSecTask.OEHbl; 
          break;
        case "T_AIMMAIN":
          jobName = JobNames.AIMbl;
          opType = constants.opTypes.airImport;
          jobTaskSec = FmsSecTask.AIMbl; 
          break;
        case "T_AIHMAIN":
          jobName = JobNames.AIHbl;
          opType = constants.opTypes.airImport;
          jobTaskSec = FmsSecTask.AIHbl; 
          break;
        case "T_AOMMAIN":
          jobName = JobNames.AEMbl;
          opType = constants.opTypes.airExport;
          jobTaskSec = FmsSecTask.AEMbl; 
          break;
        case "T_AOHMAIN":
          jobName = JobNames.AEHbl;
          opType = constants.opTypes.airExport;
          jobTaskSec = FmsSecTask.AEHbl; 
          break;
        case "T_GENMAIN":
          jobName = JobNames.OtherOP;
          opType = constants.opTypes.otherShipment;
          jobTaskSec = FmsSecTask.OtherOP; 
          break;
        case "T_WRECEIVE":
          jobName = JobNames.WHRcv;
          opType = constants.opTypes.warehousing;
          jobTaskSec = FmsSecTask.WHRcv; 
          break;
        case "T_WSHIPHD":
          jobName = JobNames.WHShip;
          opType = constants.opTypes.warehousing;
          jobTaskSec = FmsSecTask.WHShip; 
          break;
        case "T_WHPERIODINV":
          jobName = JobNames.Invoice;
          opType = constants.opTypes.warehousing;
          jobTaskSec = FmsSecTask.AcctInvoiceList; 
          break;
        case "T_WHPERIODCRDB":
          jobName = JobNames.CrDb;
          opType = constants.opTypes.warehousing;
          jobTaskSec = FmsSecTask.AcctCrDbList; 
          break;
        case "T_STORAGE":
          jobName = JobNames.WHStorageInv;
          opType = constants.opTypes.warehousing;
          jobTaskSec = FmsSecTask.WHStorageInv; 
          break;
      }
      if (model != null && !!jobTaskSec) {
        const jobGrant = findSecurityTask(appContext, jobTaskSec as FmsSecTask);
        if (jobGrant.grantRead) {
          model.extraWhere = `Id in (${args[2]})`
          model.version = versionCount.current;
          model.isSearchByReport = true;
          const listUrl = `/common/joblistview/${getListJobNameByJobName(jobName)}/${opType}`;

          setFilterForScreenExternally(
            listUrl,
            '', // filter property name in model
            '', // property label, can be omitted as ''
            'B/L G. Profit', // Filter value
            '', // order by column in model
            false,    // orderByAscending
            true,     // startWithEntry
            model  // Update version
          );
          versionCount.current += 1;
          openNewPage(history, listUrl, NavigationType.newPage);
        }
        else {
          openNewPage(history, '/home/home', NavigationType.newPage);
          showGlobalOkDialog(<p>Please check your user security!!!</p>);
        }
      }
    } else if (args[0] === 'CargoTypeYears') {
      let jobName = JobNames.None;

      switch (args[1]) {
        case "Ocean Import":
          jobName = JobNames.OIMbl;
          break;
        case "Ocean Export":
          jobName = JobNames.OEMbl;
          break;
        case "Air Import":
          jobName = JobNames.AIMbl;
          break;
        case "Air Export":
          jobName = JobNames.AEMbl;
          break;
      }

      setSelectedReportPopupMenuItem(null);

      setSelectedReportPopupMenuItem({
        label: args[1],
        popupWidth: 725,
        popupComponent:
          <VolumebyCargoTypeYears
            onPopupClose={() => setSelectedReportPopupMenuItem(null)}
            jobName={jobName}
            toDate={args[2]}
            unit={args[3]}
          />
      });
    }
    else if (args[0] === 'CustomerGrossProfit') {
      const comId = +args[1];
      const fromDate = args[2];
      const toDate = args[3];
      const department = args[4];
      const comSName = args[5] ?? '';
      // 리포트 창의 See Detail 이 클릭 시점에 미리 열어 둔 탭 이름 — 있으면 그 탭에 그린다(메인 창에서 새 팝업을 열면 차단된다)
      const targetName = args[6] || undefined;
      const channelName = 'ifms-openop-channel-' + appContext.user?.suntekId.toLowerCase() + '-' + appContext.user?.id?.toLowerCase();

      const reportWindow = openCustomerProfitLoadingWindow(windowName, comSName, targetName);
      if (reportWindow) {
        try {
          const apiResult = await appContext.api.getSalesVolumeDataByYear('MG', fromDate, toDate, department, comId);
          if (apiResult?.success) {
            renderCustomerProfit(
              reportWindow,
              apiResult.result as CustomerProfitByYear[],
              new Date(toDate),
              appContext.suntekSettings?.company?.comName ?? '',
              appContext.systemSettings?.primaryCurrency ?? '',
              department,
              comSName,
              channelName,
              windowName,
              `Source data: Sales/Volume (B/L Based) report · Printed by ${appContext.user?.name ?? ''}`
            );
          } else {
            renderErrorIntoWindow(reportWindow, 'No Data Found.');
          }
        } catch (e) {
          renderErrorIntoWindow(reportWindow, 'Report Error');
        }
      }
    }
    else if (args[0] === 'TotalSalesClient') {
      const toDate = args[1];
      const fromDate = args[2];
      const salesBasis = args[3];
      const department = args[4];
      const reportOption = args[5] ?? 'Op5Year';
      const channelName = 'ifms-openop-channel-' + appContext.user?.suntekId.toLowerCase() + '-' + appContext.user?.id?.toLowerCase();

      const customerViews = {
        Op5Year: {
          open: openTotalSalesCustomerLoadingWindow,
          fetch: () => appContext.api.getTotalSalesCustomerData5Year('MG|I', fromDate, toDate, department, salesBasis),
          render: renderTotalSalesCustomer5Year,
        },
        OpQuarterly: {
          open: openTotalSalesCustomerQuarterlyLoadingWindow,
          fetch: () => appContext.api.getTotalSalesCustomerDataQuarterly('MG|I', fromDate, toDate, department, salesBasis),
          render: renderTotalSalesCustomerQuarterly,
        },
        OpMonthly: {
          open: openTotalSalesCustomerMonthlyLoadingWindow,
          fetch: () => appContext.api.getTotalSalesCustomerDataMonthly('MG|I', fromDate, toDate, department, salesBasis),
          render: renderTotalSalesCustomerMonthly,
        },
      } as const;

      const view = customerViews[reportOption as keyof typeof customerViews];
      if (!view) {
        console.warn(`[TotalSalesClient] unsupported reportOption: "${reportOption}"`);
        return;
      }

      const reportWindow = view.open(windowName);
      if (reportWindow) {
        const apiResult = await view.fetch();

        if (!apiResult.success || apiResult.result.length <= 0) {
          renderErrorIntoWindow(reportWindow, 'No Data Found.');
          return;
        }

        const asOfDate = toDate ? new Date(toDate) : new Date();
        view.render(
          reportWindow,
          apiResult.result as SalesCostByCustomer[],
          asOfDate,
          appContext.suntekSettings?.company?.comName ?? '',
          appContext.systemSettings?.primaryCurrency ?? '',
          salesBasis,
          department,
          channelName,
          fromDate,
          toDate,
          `Source data: Total Sales (Customer) report · Printed by ${appContext.user?.name ?? ''}`
        );
      }
    }
    else if (args[0] === 'BusinessChartToListView') {
      // ["BusinessChartToListView", opCode, asOfDate | "from~to", customerId, nodeType, agentId, shipperName, blDate, baseType]
      //  기간 모드(Monthly / Quarterly 에서 연 Business Chart)면 날짜 자리에 "from~to" 가 온다. 날짜 하나면 기존처럼 5년.
      const opCode = (args[1] ?? '').toUpperCase();
      const { from: fromDate, to: asOfDate } = splitPeriod(args[2]);
      const customerId = Number(args[3]) || 0;
      const nodeType = args[4] ?? '';          // CUSTOMER | AGENT | SHIPPER | MONTH
      const agentId = Number(args[5]) || 0;
      const shipperName = args[6] ?? '';
      const blDate = args[7] ?? '';
      const baseType: 'CUSTOMER' | 'AGENT' = args[8] === 'AGENT' ? 'AGENT' : 'CUSTOMER';   // 기준 업체가 Customer 인지 Agent 인지

      switch (opCode) {
        case 'OI': jobName = JobNames.OIHbl; opType = constants.opTypes.oceanImport; jobTaskSec = FmsSecTask.OIHbl; break;
        case 'OE': jobName = JobNames.OEHbl; opType = constants.opTypes.oceanExport; jobTaskSec = FmsSecTask.OEHbl; break;
        case 'AI': jobName = JobNames.AIHbl; opType = constants.opTypes.airImport; jobTaskSec = FmsSecTask.AIHbl; break;
        case 'AE': jobName = JobNames.AEHbl; opType = constants.opTypes.airExport; jobTaskSec = FmsSecTask.AEHbl; break;
        case 'OT': jobName = JobNames.OtherOP; opType = constants.opTypes.otherShipment; jobTaskSec = FmsSecTask.OtherOP; break;
      }
      if (!jobName || !jobTaskSec || !asOfDate) return;

      const jobGrant = findSecurityTask(appContext, jobTaskSec as FmsSecTask);
      if (!jobGrant.grantRead) {
        showGlobalOkDialog(<p>Please check your user security!!!</p>);
        return;
      }

      // fromDate 가 비어 있으면 서버가 기존처럼 asOfDate 기준 5년으로 조회한다
      apiResult = await appContext.api.getSankeyNodeIds(opCode, asOfDate, customerId, nodeType, agentId, shipperName, blDate, baseType, fromDate);
      if (!apiResult?.success) {
        showGlobalOkDialog(<p>{apiResult?.message || 'Failed to load data.'}</p>, false, 'Error');
        return;
      }

      const ids = (apiResult.result ?? []) as number[];
      if (ids.length === 0) {
        showGlobalOkDialog(<p>There is no information to display.</p>, false, 'Error');
        return;
      }
      // if (ids.length > 5000) {
      //   showGlobalOkDialog(<p>{`Too many records (${ids.length.toLocaleString()}). Please select a more specific node.`}</p>, false, 'Error');
      //   return;
      // }

      const model = new SearchModelBase();
      model.extraWhere = `Id in (${ids.join(',')})`;
      model.version = versionCount.current;
      model.isSearchByReport = true;

      const listUrl = `/common/joblistview/${getListJobNameByJobName(jobName)}/${opType}`;

      setFilterForScreenExternally(
        listUrl,
        '',               // filter property name in model
        '',               // property label
        'Business Chart', // Filter value
        '',               // order by column in model
        false,            // orderByAscending
        true,             // startWithEntry
        model
      );
      versionCount.current += 1;
      openNewPage(history, listUrl, NavigationType.newPage);
    }
    else if (args[0] === 'BusinessChartDashboard') {
      // ["BusinessChartDashboard", baseId, baseName, asOfDate | "from~to", department, baseType?, targetName?, allowFallback?]
      //  날짜 자리: "2026-10-26"(5년) 또는 "2026-01-01~2026-10-26"(기간 모드 — Monthly / Quarterly 리포트)
      //  baseType 없으면 'CUSTOMER'
      //  targetName: 팝업의 View as … 링크가 클릭 시점에 미리 열어 둔 탭 이름(없으면 새 탭)
      //  allowFallback '1': 기준을 AGNT 그룹으로 추정한 경우(Total Sales 표 버튼) → 데이터 없으면 반대 기준으로 한 번 더 조회
      const baseId = Number(args[1]) || 0;
      const baseName = args[2] ?? '';
      const { from: fromDate, to: asOf } = splitPeriod(args[3]);
      const department = args[4] ?? '';
      const baseType: 'CUSTOMER' | 'AGENT' = args[5] === 'AGENT' ? 'AGENT' : 'CUSTOMER';
      const targetName = args[6] || undefined;
      const allowFallback = args[7] === '1';
      if (!baseId || !department) return;

      const suntekId = appContext.user?.suntekId?.toLowerCase();
      const userId = appContext.user?.id?.toLowerCase();
      const windowName = `ifmsmain-${suntekId}-${userId}`;
      const reportWindow = openBusinessChartLoadingWindow(windowName, baseName, targetName);
      if (!reportWindow) return;

      const order: ('CUSTOMER' | 'AGENT')[] = allowFallback
        ? (baseType === 'AGENT' ? ['AGENT', 'CUSTOMER'] : ['CUSTOMER', 'AGENT'])
        : [baseType];
      let shownBaseType: 'CUSTOMER' | 'AGENT' | '' = '';
      let r1: any = null;
      let r2: any = null;
      for (const bt of order) {
        const customerId = bt === 'AGENT' ? 0 : baseId;
        const agentId = bt === 'AGENT' ? baseId : 0;
        // fromDate 가 비어 있으면 서버가 기존처럼 asOf 기준 5년으로 조회한다
        r1 = await appContext.api.getSankeyDiagram(department, asOf, customerId, agentId, bt, fromDate);
        r2 = await appContext.api.getMonthlyChart(department, asOf, customerId, agentId, bt, fromDate);
        if (!r1?.success || !r2?.success) {
          renderErrorIntoWindow(reportWindow, r1?.message || r2?.message || 'Failed to load data.');
          return;
        }
        const hasData = r1.result.length > 0 || r2.result.some((d: MonthlyData) => Number(d.volume) > 0);
        if (hasData) { shownBaseType = bt; break; }
      }
      if (!shownBaseType) {
        renderErrorIntoWindow(reportWindow, allowFallback
          ? 'No Associated B/L.'
          : `No shipments found as ${baseType === 'AGENT' ? 'Agent' : 'Customer'}.`);
        return;
      }
      const notice = shownBaseType !== baseType
        ? `No shipments found as ${baseType === 'AGENT' ? 'Agent' : 'Customer'} — showing the ${shownBaseType === 'AGENT' ? 'Agent' : 'Customer'} view instead.`
        : '';

      renderBusinessChart(
        reportWindow,
        r1.result,
        r2.result,
        asOf ? new Date(asOf) : new Date(),
        asOf,
        appContext.suntekSettings?.company?.comName ?? '',
        baseName,
        baseId,
        shownBaseType,
        department,
        `ifms-openop-channel-${suntekId}-${userId}`,
        windowName,
        `Source data: Business Chart · Printed by ${appContext.user?.name ?? ''}`,
        notice,
        false,      // canSwitch — 기존 호출부와 같은 값(넘기지 않던 기본값 false)
        fromDate    // 기간 모드 시작일. 비면 5년 화면
      );
    }
    else {
      //optab-rptviewer
      //openNewPage(history, `/common/report/${e.data.Target}`, NavigationType.newPage);
      const reportId = decodeURIComponent(e.data.Target);
      const hlinkData = reportId.split('^');
      if ([ReportHyperKey.DutyPendings, ReportHyperKey.NewProfitDetail1, 
        ReportHyperKey.NewProfitDetail2, ReportHyperKey.NewProfitDetail2GP, 
        ReportHyperKey.EmpPerformanceDetail, ReportHyperKey.DutyDetail].indexOf(hlinkData[0] as ReportHyperKey) >= 0) {
        // Find last operation before selecting report menu
        opType = _.findKey(constants.operations, x => x === selectedOperation) ?? '';
      } else {
        opType = constants.opTypes.accounting;
      }

      if ([ReportHyperKey.JournalVoucher, ReportHyperKey.JournalVoucherWithJournal].indexOf(hlinkData[0] as ReportHyperKey) >= 0) {
        if (!getSecBySecTask(appContext, FmsSecTask.AcctSlipJournalList, SecType.Read) && !(appContext?.user?.id?.startsWith('@') ?? false)) return;
      }

      if (hlinkData[0].substring(0, 4).toUpperCase() === "HTTP")
        window.open(hlinkData[0]);
      else
        viewReport(reportId, opType, true, true);
    }
  }

  // async function getReminderTime(){  
  //   const resultTime = await appContext.api.getReminderTaskTime(appContext.user ? appContext.user.id ?? '' : '');
  //   let tempInfoContent = appContext.appInfoAreaContent;
  //   if(!!resultTime){ //setSystemSettings가 바로 갱신이 안되어 강제로 값 변경
  //     if(appContext.systemSettings){
  //         appContext.systemSettings.reminderStatus = resultTime[0] ?? '';
  //       appContext.systemSettings.reminderTime = resultTime[1] ?? '';
  //       appContext.systemSettings.reminderDueTime = resultTime[2] ?? '';
  //     }
  //     //IfmsTopBar > Reminder Icon이 바로 갱신되지 않아 강제로 값 변경
  //       appContext.setSystemSettings({
  //         reminderStatus: resultTime[0] ?? '',
  //       reminderTime : resultTime[1] ?? '',
  //       reminderDueTime: resultTime[2] ?? '',
  //       });
  //     }
  //   appContext.setAppInfoAreaContent(tempInfoContent);
  // }

  function stayLoggedin() {
    appContext.logoutWorker?.postMessage(['clearTimeout', autoLogoutRemainTimerId.current]);

    appContext.logoutWorker?.postMessage(['getAutoLogoutRemainInit']);
    appContext.logoutWorker?.postMessage(['setAutoLogoutTimer', autoLogoutTimerId.current]);
    setAutoLogoutCheck(false);
  }

  useEffect(() => {
    if (autoLogoutRemain <= 0) {
      if(!isStayLoggin.current)
        timeLogout();
      else 
        isStayLoggin.current = false;
    }
  }, [autoLogoutRemain]);

  async function timeLogout() {
    // console.log(`timeout. clear.`);
    appContext.logoutWorker?.postMessage(['clearTimeout', autoLogoutTimerId.current]);
    setAutoLogoutCheck(false);

    // console.log(`timeout. logout.`);
    await logoutUser(false); 
  }


  function handlePageHide(e: PageTransitionEvent) {
    if (window.name.indexOf('ifmssub') === -1) {
      broadcastChannel?.postMessage({ Target: 'CloseWindow' });
    }
  }

  useEffect(() => {
    
    // To clear old localforage storage, collect by 
    const clearLocalStorage = async() => {
      const keys = await localforage.keys();
      // tableName: [key1, key2]
      const listKeys = _.groupBy(keys, (k) => k.split('tbl-list')[1]);
      _.keys(listKeys).forEach((p) => {
        let maxKey = _.maxBy(listKeys[p], (k) => k.split('-tbl-list')[0].replace('table-v-', '').replace('-', ''));
        // remove except maxKey
        listKeys[p].forEach((k) => {
          if(k !== maxKey)
            localforage.removeItem(k);
        });
      });
    }    
    clearLocalStorage();
    //

    subscribeChannels();

    // AI Settings 켜짐 여부 (AI Center 메뉴·AI Drop Zone 아이콘) — CSQ Server 에서 한 번 읽는다 (2026-10-06)
    // AI 를 쓰는 회사(BVLG005690)가 아니면 서버에 묻지 않고 전부 꺼짐 (2026-10-12)
    setAiTenant(appContext.user?.suntekId);
    setAiCenterGrant(getSecBySecTask(appContext, FmsSecTask.AICenter, SecType.Read));
    refreshAiCenterFlags();

    //<pt220314: Please remember that BroadcastChannel works only when publisher and subscriber 
    //  must be open under the same host:port and same proptocol. So, under development environment
    //  yarn build and copy build folder to iFms.Api project's frontend\build folder:
    //  "PS E:\Projects\ifms.web-proto\frontend-typescript> xcopy /s /r /y .\build\*.* ..\api\src\iFms.Api\frontend\build\"
    //  and run VS2022.
    //  Open browser independently with url http://localhost:5000/index.html, then login page appears.
    //  Start debugging here.
    broadcastChannel = new BroadcastChannel('ifms-openop-channel-' + appContext.user?.suntekId.toLowerCase() + '-' + appContext.user?.id?.toLowerCase());
    broadcastChannel.addEventListener('message', bcMessageHandler);
    //pt220314>

    // Back handler - don't allow it. Depend on the double push logic inside navigation helpers
    window.addEventListener("popstate", e => {
      history.go(1);
    });

    // const newOperation = operationFactory(history.location.pathname, userLogin.user?.defaultOperation);
    const newOperation = 'Home';

    if (selectedOperation !== newOperation) {
      setSelectedOperation(operationFactory(newOperation));
    }

    window.addEventListener('mousemove', tooltipMonitor);

    if (appContext.logoutWorker) {
      appContext.logoutWorker.onmessage = function (event) {
        //console.log('logoutWorker.onmessage:', event.data);

        switch (event.data[0]) {
          case 'fireLogoutReaminTimer':
            //console.log('logoutWorker.onmessage:', event.data);
            setAutoLogoutCheck(true);

            appContext.logoutWorker?.postMessage(['getAutoLogoutRemainInit']);
            appContext.logoutWorker?.postMessage(['createInterval']);
            break;
          case 'setTimerId':
            //console.log('logoutWorker.onmessage:', event.data);
            appContext.logoutWorker?.postMessage(['clearTimeout', autoLogoutTimerId.current]);
            autoLogoutTimerId.current = event.data[1];
            break;
          case 'setAutoLogoutRemain':
            setAutoLogoutRemain(event.data[1]);
            break;
          case 'setRemainTimerId':
            //console.log('logoutWorker.onmessage:', event.data);
            autoLogoutRemainTimerId.current = event.data[1];
            break;
        }
      };
    }

    window.addEventListener('keydown', (e) => {
      globalDirtyMarkCleaner(e);
      appContext.logoutWorker?.postMessage(['setAutoLogoutTimer', autoLogoutTimerId.current]);
    });
    window.addEventListener('click', (e) => {
      appContext.logoutWorker?.postMessage(['setAutoLogoutTimer', autoLogoutTimerId.current]);
    });
    // window.addEventListener('unload', (e) => {
    //   if (window.name.indexOf('ifmssub') === -1) broadcastChannel?.postMessage({Target:'CloseWindow'});
    // });
    window.addEventListener('pagehide', handlePageHide);

    




    if (!initialized) {  //fire once.
      appContext.logoutWorker?.postMessage(['getAutoLogoutRemainInit']);
      appContext.logoutWorker?.postMessage(['setAutoLogoutTimer', autoLogoutTimerId.current]);
    }

    return unsubscribeAll;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedOperation === null) {
      // Initial setup
      // setInitialized(true);
      return;
    }

    if (!initialized) {
      setInitialized(true);
      redirectToUserDefaultUrl();
      return;
    }

    // const currentUrl = `${history.location.pathname}${history.location.search}`;
    // const operationKey = getOperationKey(selectedOperation);

    // if (!operationKey) {
    //   return;
    // }

    // let currentScreenUrlForOperation = _.last(screenStack[operationKey]);

    // if(history.location.search?.indexOf('parentOp') > -1){
    //   currentScreenUrlForOperation = _.last([...screenStack[operationKey], 
    //     ...screenStack.accounting, 
    //     ...screenStack.oceanExport, 
    //     ...screenStack.airExport]);
    // }

    // if (currentScreenUrlForOperation && !stringsEqualIgnoreCase(currentUrl, currentScreenUrlForOperation.url)) {
    //   openNewPage(history, currentScreenUrlForOperation.url, NavigationType.newPage);
    // } 
    // else {
    //   const specialOperations = ['Other Shipment', 'Customer List', 'Standalone'];
    //   if (specialOperations.every(x => x !== selectedOperation)) {
    //     // Show operation home scren
    //     openNewPage(history, '/home/home', NavigationType.newPage);
    //   }
    // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOperation]);

 
  // useInterval(() => {
  //   appContext.setUseCheckReminder(!appContext.useCheckReminder);
  // },_isRunning.current ? TaskReminderTimer: null);

  // useEffect(() => {
  //   const getTime = async () => {
  //     appContext.setAppInfoAreaContent(appContext.appInfoAreaContent);
  //     await getReminderTime();

  //     if(appContext.systemSettings?.reminderStatus === 'R'){
  //       if(!appContext.showReminderPop.isOpen) appContext.setShowReminderPop({isOpen: true, top: '600px', left:'1100px'});
  //     }
  //     if(appContext.systemSettings?.reminderDueTime !== ''){
  //       _isRunning.current = true;
  //     } else {
  //       _isRunning.current = false;
  //     }
  //   };
  //   getTime();
  // },
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // [appContext.useCheckReminder ]);

  // memo popup창을 자동으로 open 해주는 기능 사용하지 않아 주석 처리
  // useEffect(() => {
  //   if (!appContext.showReminderPop.isOpen || appContext.openMemoDetail) {
  //     setTimeout(() => {
  //       if(appContext.myMemoTaskReminder){
  //         const editButton = document.getElementById('memo-log-edit-button');
  //         if (editButton) {
  //           editButton.click();
  //         }
  //       }
  //     }, 2300);
  //   }
  // }, [appContext.showReminderPop.isOpen, appContext.openMemoDetail]);


  useEffect(() => {
    if (focusEleAfterModalOkBtnClick) {
      setTimeout(() => {
        if (getCurrentTabableIndex(document.activeElement) < 0) {
          (focusEleAfterModalOkBtnClick as HTMLElement).focus()
        }
        setFocusEleAfterModalOkBtnClick(null);
      }, 200);
    }
  }, [focusEleAfterModalOkBtnClick])

  useEffect(() => {
    darkModeRef.current = appContext.useDarkMode;
    processTooltip();
  }, [appContext.useDarkMode]);

  function unsubscribeAll() {
    unsubscribeChannels();

    //<pt220314>
    if(broadcastChannel) {
      // window.removeEventListener('unload', (e) => {
      //   if (window.name.indexOf('ifmssub') === -1) broadcastChannel?.postMessage({Target:'CloseWindow'});
      // });
      window.removeEventListener('pagehide', handlePageHide);
      broadcastChannel.removeEventListener('message', bcMessageHandler);
      broadcastChannel.close();
    }
    deleteAllTooltipsFromDom();  //logout시 tooltip이 남아있는 문제가 있어 추가
    window.removeEventListener('mousemove', tooltipMonitor);
    window.removeEventListener('keydown', (e) => {
      globalDirtyMarkCleaner(e);
      appContext.logoutWorker?.postMessage(['setAutoLogoutTimer', autoLogoutTimerId.current//, autoLogoutReaminTimerId.current
      ]);
    });
    window.removeEventListener('click', (e) => {
      appContext.logoutWorker?.postMessage(['setAutoLogoutTimer', autoLogoutTimerId.current//, autoLogoutReaminTimerId.current
      ]);
    });

    appContext.logoutWorker?.terminate();
  }

  function subscribeChannels() {
    navigationSubscription = postal.subscribe({
      channel: 'ifms-navigation',
      topic: 'ifms-navigation.urlChange',
      callback: link => {
        if (activeUrlRef.current !== link) {
          activeUrlRef.current = link;
          const ish = defaultUrls.includes(link);
          if (isHomeRef.current !== ish) {
            isHomeRef.current = ish;
            setIsHome(ish);
          }
        }
      }
    });
    ajaxErrorSubscription = postal.subscribe({
      channel: 'ajax',
      topic: 'ajax.error',
      callback: error => onApiError(error)
    });
    viewReportSubscription = postal.subscribe({
      channel: 'report',
      topic: 'report.view',
      callback: ({reportId, opType, jwt}) => {
        //<pt220406: optab-rptviewer
        // if (reportRef && reportRef.current) {
        //   reportRef.current.viewReport(reportId);
        // }
        //debugger;
        openNewPage(history, `/common/report/${encodeURIComponent(reportId)}/${opType}`, NavigationType.newPage);
        //pt220406>
      }
    });
    // move to login page //<240221.dwshin>
    movetologinSubscription = postal.subscribe({
      channel: 'ajax',
      topic: 'ajax.movetologin',
      callback: () => moveToLoginPage()
    });
  }

  function unsubscribeChannels() {
    if (navigationSubscription) {
      postal.unsubscribe(navigationSubscription);
    }
    if (ajaxErrorSubscription) {
      postal.unsubscribe(ajaxErrorSubscription);
    }
    if (ajaxStartSubscription) {
      postal.unsubscribe(ajaxStartSubscription);
    }
    if (ajaxEndSubscription) {
      postal.unsubscribe(ajaxEndSubscription);
    }
    if (loadingStartSubscription) {
      postal.unsubscribe(loadingStartSubscription);
    }
    if (loadingEndSubscription) {
      postal.unsubscribe(loadingEndSubscription);
    }
    if (viewReportSubscription) {
      postal.unsubscribe(viewReportSubscription);
    }
    if (tableEditSubscription) {
      postal.unsubscribe(tableEditSubscription);
    }
    if (movetologinSubscription) {
      postal.unsubscribe(movetologinSubscription);
    }
  }

  function redirectToUserDefaultUrl() {
    if (!userLogin.user) {
      return;
    }

    

    if (userLogin.user.moveToAutoLogin) {
      moveToAotherPage(userLogin.user.moveToAutoLogin);
    }else if (currentUrl !== '/home/home') {
      openNewPage(history, '/home/home', NavigationType.newPage);
    }
  }

  function moveToAotherPage(info: string){

    const moveInfo = info.split(';');
    // type=detail;url=url                // array 2
    // type=list;url=url;searchinfo=info  // array 3
    
    
    // type detail
    if (moveInfo?.length > 1) {
      var type = moveInfo[0].replace('type=', '');

      switch (type) {
        case 'detail':
          var url = moveInfo[1].replace('url=', '');
          window.name = `ifmssub-hblinfo-${url}-${appContext.user?.suntekId?.toLowerCase()}-${appContext.user?.id?.toLowerCase()}`;
          openNewPage(history, url, NavigationType.newPage);

          break;
        // case 'list':
        //     var url = moveInfo[1].replace('url=', '');
        //     //console.log(`url`, url);
        //     eval(url);
        //   break;
      }

    }

  }

  function globalDirtyMarkCleaner(e:KeyboardEvent) {
    const element = e.target;
    if (element && element instanceof HTMLElement ) {
      const validationFor = element?.dataset?.validationfor;
      if (validationFor) {
        const dirtyElementsForProperty = document.querySelectorAll(`[data-validationfor="${validationFor}"]`);
        for (let i = 0; i < dirtyElementsForProperty.length; ++i) {
          dirtyElementsForProperty[i].classList.remove('ifms-validation-error');
        }
      }

      element.classList.remove('ifms-validation-error');
    }
  }

  function isHTMLElement(element: Element): element is HTMLElement {
    return 'className' in element && (typeof element.className === 'string');
  }

  function tooltipMonitor(e:MouseEvent) {
    const hoverElements = document.elementsFromPoint(e.clientX, e.clientY);

    const hasHeaderFilterModal = hoverElements.some(element => isHTMLElement(element) && element.className.includes("header-filter-modal"));

    if(hasHeaderFilterModal) {
      deleteAllTooltipsFromDom();
      return;
    }

    if (!hoverElements || hoverElements.length <= 0) {
      if (tooltipElement) {
        tooltipElement = null;
        processTooltip();
      }
      return;
    }

    for (let i = 0; i < hoverElements.length; ++i) {
      const el = hoverElements[i];
      if (!(el instanceof HTMLElement || el instanceof SVGElement)) {
        continue;
      }
      if (el.dataset.tooltip) {
        if (el === tooltipElement) {
          return;
        }

        tooltipElement = el;
        processTooltip();
        return;
      }
    }

    if (tooltipElement) {
      tooltipElement = null;
      processTooltip();
    }
  }

  function processTooltip() {
    const isBlank = (str: string | null | undefined) => (!str || /^\s*$/.test(str));

    if (tooltipElement) {
      if (!!tooltipElement.dataset.tooltipOnlywhencutoff) {
        const cutoffTarget = (tooltipElement.querySelector('[data-tooltip-cutoff-target]') as HTMLElement | null) ?? tooltipElement;

        if (cutoffTarget.scrollWidth <= cutoffTarget.clientWidth) {
          deleteAllTooltipsFromDom();
          return;
        }
      }
      let tooltipText = tooltipElement.dataset.tooltip;
      if (tooltipText === '-from-value' && !(tooltipElement instanceof SVGElement)) {
        const inputElement = tooltipElement as HTMLInputElement;
        if (inputElement.value) {
          tooltipText = inputElement.value;
        } else {
          tooltipText = tooltipElement.textContent ?? undefined;
        }
      }
      if (isBlank(tooltipText)) {
        deleteAllTooltipsFromDom();
        return;
      }

      let fragment: DocumentFragment = createFragment('');
      //modal의 table에 표시되는 tooltip이 modal 뒤에 표시되는 문제가 있어 z-index를 변경함
      let modalzIndex = tooltipElement.dataset.tooltipTabletype === "modal" ? 888891 : tooltipElement.dataset.tooltipTabletype === "lookup" ? 1000000000 : 888889;
      fragment = createFragment(`<div class="ifms-tooltip" style="position: absolute; display: inline-block; z-index:${modalzIndex};">${tooltipText}</div>`);

      const firstChildNode = fragment.childNodes[0];
      if (!(firstChildNode instanceof HTMLElement)) {
        return;
      }

      const fragmentPosition = getTooltipPosition(firstChildNode);

      firstChildNode.style.left = `${fragmentPosition.left}px`;
      firstChildNode.style.top = `${fragmentPosition.top}px`;

      deleteAllTooltipsFromDom();
      document.body.appendChild(firstChildNode);

      // Tooltip 위치 보정 - Right 넘어갈 때
      if (firstChildNode.offsetLeft + firstChildNode.offsetWidth > document.body.offsetWidth) {
        if (firstChildNode.offsetLeft > document.body.offsetWidth) fragmentPosition.left = document.body.offsetWidth;
        firstChildNode.style.left = `${fragmentPosition.left - firstChildNode.offsetWidth}px`
      }

      // Tooltip 위치 보정 - Top 넘어갈 때
      if (fragmentPosition.top < 0) {
        firstChildNode.style.top = `${fragmentPosition.top + firstChildNode.offsetHeight + VirtualTableRowHeight}px`
      }

      // Is special tooltip (INV, BIL, Consignee, Shipper...)
      if (tooltipElement.dataset.tooltipposition === 'listview-cell') {
        const childInfo = firstChildNode.getBoundingClientRect()
        firstChildNode.style.top = `${childInfo.top - childInfo.height}px`;
      }   
      
      if (['user-button', 'tab-tooltip', 'expresssearch'].includes(tooltipElement.dataset.tooltipposition ?? '')) {
        firstChildNode.classList.add((darkModeRef.current ? 'tab-dark' : 'tab'));
      } 

    } else {
      deleteAllTooltipsFromDom();
    }
  }

  function deleteAllTooltipsFromDom() {
    const visibleTooltips = document.querySelectorAll('.ifms-tooltip');
      if (visibleTooltips && visibleTooltips.length > 0) {
        for (let i = 0; i < visibleTooltips.length; ++i) {
          const t = visibleTooltips[i];
          if (t.parentElement) {
            t.parentElement.removeChild(t);
          }
        }
      }
  }

  async function onApiError(error:any) {
    const color = error.errorType === 'warning' ? '#f7c82d' : '#bd3737';
    await showGlobalOkDialog(
      <div>
        <div>
          <h5>
            <span style={{color}}><FontAwesomeIcon icon={faExclamationTriangle} /></span> {error.errorTitle}
          </h5>
        </div>
        <div dangerouslySetInnerHTML={{__html: error.errorText}}></div>
      </div>
    );
  }

  async function purgeLocalStorage() {
    const keys = await localforage.keys();

    const toDelete:Array<string> = [];
    keys.forEach(k => {
      if (k.startsWith('filter-')) {
        toDelete.push(k);
      }
    });

    for (let i = 0; i < toDelete.length; ++i) {
      await localforage.removeItem(toDelete[i]);
    }

    _.forOwn(fastStorage, (_, k) => {
      delete fastStorage[k];
    });
  }

  async function logoutUser(showLogoutAlert: boolean = true, authLogoff: boolean = true) {
    // Find are there any screens that should be closed on logout and prompt for confirmation
    function distinct(value:JobMenuItem, index:number, self:Array<JobMenuItem>) {
      return self.findIndex(x => stringsEqualIgnoreCase(x.url, value.url)) === index;
    }

    // const jobMenuItemsToCloseOnLogout = [
    //   ...jobMenu.oceanImport.filter(x => x.closeOnLogout),
    //   ...jobMenu.oceanExport.filter(x => x.closeOnLogout),
    //   ...jobMenu.airImport.filter(x => x.closeOnLogout),
    //   ...jobMenu.airExport.filter(x => x.closeOnLogout),
    //   ...jobMenu.otherShipment.filter(x => x.closeOnLogout),
    //   ...jobMenu.accounting.filter(x => x.closeOnLogout),
    //   ...jobMenu.warehousing.filter(x => x.closeOnLogout),
    // ].filter(distinct);

    // Implementation note:
    //   Remove all screens on logout, not just children, but leave the code in case it needs to be turned back on
    const allJobMenuItemsToCloseOnLogout = [
      ...jobMenu.home,
      ...jobMenu.oceanImport,
      ...jobMenu.oceanExport,
      ...jobMenu.airImport,
      ...jobMenu.airExport,
      ...jobMenu.otherShipment,
      ...jobMenu.whReceipt,
      ...jobMenu.accounting,
      ...jobMenu.warehousing,
      ...jobMenu.opReport,
      ...jobMenu.customer,
      ...jobMenu.standalone,
      ...jobMenu.utility,
      ...jobMenu.billings,
      ...jobMenu.ams,
      ...jobMenu.isf,
      ...jobMenu.myTask,
      ...jobMenu.shipmentStatus,
    ].filter(x => !stringsEqualIgnoreCase('Home', x.label)).filter(distinct);

    let doLogout = true;

    // if (showLogoutAlert && allJobMenuItemsToCloseOnLogout.length > 0) {
    //   doLogout = await showGlobalDialog(
    //     <div>
    //       <h3>Are you sure you want to logout?</h3>

    //       {/* There are opened screens:
    //       <br />
    //       <br />
    //       {allJobMenuItemsToCloseOnLogout.map((x, i) => (
    //         <li key={i}>{x.label}</li>
    //       ))} */}
    //     </div>
    //   );
    // }

    if (doLogout) {
      if(authLogoff && (process.env.NODE_ENV === 'production')){
        // authentication service logoff call
        await appContext.api.authenticateLogoff();
      }
      await purgeLocalStorage();

      // report tab all close
      if (window.name.indexOf('ifmssub') === -1) broadcastChannel?.postMessage({Target:'CloseWindow'});
      // clear window name
      window.name = '';
      // clear logout timeout.
      appContext.logoutWorker?.postMessage(['clearTimeout', autoLogoutTimerId.current]);

      cleanupAll();

      dispatch(clearStorage());
      dispatch(clearOperation());
      dispatch(resetListScreenSettings());
      dispatch(logout());
      dispatch(clearLastSavedJobs());

      stopRemindTimer(); //Task Timer 중지
      appContext.onLogout();

      history.push('/');
    }
  }



  async function moveToLoginPage(){
    let userId = appContext?.user?.id;

    await showGlobalOkDialog(
      <div>
        <h3>Someone has logged in with the same ID{userId ? `(${userId})` : '' }
          <br />So You are automatically logged out.</h3>
      </div>
    );
    
    await logoutUser(false, false);
  }

  //for HelpButton
  async function openESupportPage() {
    const openURL: string = await appContext.api.getESupportURL(fmsGlobal.AcmeID)
    window.open(openURL);
  }

  //for HelpButton
  async function checkFileServer() {
    postal.publish({
      channel: 'ajax',
      topic: 'ajax.loadingwithmessagestart',
      data: { message: "Please wait while checking file server..." }
    });

    const apiResult2: ApiResult<InsertResultsWithData> = await appContext.api.checkfileserver();

    postal.publish({
      channel: 'ajax',
      topic: 'ajax.loadingwithmessageend',
      data: {}
    });

    if (apiResult2 && apiResult2.success) {
      await showGlobalOkDialog(<p>File Server is working!</p>);
    } else {
      await showGlobalOkDialog(<p>File Server is not working!</p>);
    }
  }

  //for HelpButton
  async function setMilestoneOption(jobName: string) {
    let msg = '';
    if (jobName === 'OIH') {
      if (hasOpenedScreenStartingWithUrl('/common/joblistview/hbl/oceanImport')) {
        await showGlobalOkDialog(<p>Please close HBL List (OI)</p>);
        return;
      }
      let sqlInfos: SQLInfo[] = [];
      sqlInfos.push(new SQLInfo({
        tableName: "T_SETTINGS",
        type: SQLType.Update,
        fields:[
          new SQLField({fieldName: "F_Value", propertyName:'showMilestoneInOihList',value: !appContext.systemSettings?.showMilestoneInOihList})
        ],
        whereFields:[
          new SQLField({fieldName:"F_Name", propertyName:'', value:'ShowMilestoneInOihList'})
        ]
      }))

      const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.saveJobDetail(JobNames.SystemSetup,
        sqlInfos,
        {});

       if(apiResult && apiResult.success){
        appContext.setSystemSettings({
          ...appContext.systemSettings,
          showMilestoneInOihList: !appContext.systemSettings?.showMilestoneInOihList,
        });

        msg = appContext.systemSettings?.showMilestoneInOihList ? 'OIH B/L Activity Status Off' : 'OIH B/L Activity Status On'
        await showGlobalOkDialog(<p>{msg}</p>);
       }  
    }
    else {
      if (hasOpenedScreenStartingWithUrl('/common/joblistview/aiHawb/airImport')) {
        await showGlobalOkDialog(<p>Please close HAWB List (AI)</p>);
        return;
      }
      
      let sqlInfos: SQLInfo[] = [];
      sqlInfos.push(new SQLInfo({
        tableName: "T_SETTINGS",
        type: SQLType.Update,
        fields:[
          new SQLField({fieldName: "F_Value", propertyName:'showMilestoneInAihList', value: !appContext.systemSettings?.showMilestoneInAihList})
        ],
        whereFields:[
          new SQLField({fieldName:"F_Name", propertyName:'', value:'ShowMilestoneInAihList'})
        ]
      }))
      const apiResult: ApiResult<InsertResultsWithData> = await appContext.api.saveJobDetail(JobNames.SystemSetup,
        sqlInfos,
        {});

      if(apiResult && apiResult.success){
        appContext.setSystemSettings({
          ...appContext.systemSettings,
          showMilestoneInAihList: !appContext.systemSettings?.showMilestoneInAihList,
        });
        msg = appContext.systemSettings?.showMilestoneInAihList ? 'AIH B/L Activity Status Off' : 'AIH B/L Activity Status On'
        await showGlobalOkDialog(<p>{msg}</p>);
      }
    }
  }

  async function checkStandaloneDirty() {
    //if(selectedOperation !== 'Standalone') return;
    if(!['Standalone','My Task'].includes(selectedOperation)) return;

    if (fastStorage['ifms-settings-haschanges']) {
      const doSave = await showGlobalYesNoDialog(
        <div>
          There are unsaved changes. Do you want to save?
        </div>
      ,false, 1, true, 'info');

      const externalFunctions = getExternalFunctions();
      if (doSave) {
        await externalFunctions.ifmsSettingsSave();
      } else {
        await externalFunctions.ifmsSettingsCancel();
      }
      fastStorage['ifms-settings-haschanges'] = false;
    }
    else if (fastStorage['ifms-referenceFiles-haschanges']) {
      const doSave = await showGlobalYesNoDialog(
        <div>
          There are unsaved changes. Do you want to save?
        </div>
      ,false, 1, true, 'info');

      const externalFunctions = getExternalFunctions();
      if (doSave) {
        await externalFunctions.ifmsReferenceFilesSave();
      } else {
        await externalFunctions.ifmsReferenceFilesCancel();
      }
      fastStorage['ifms-referenceFiles-haschanges'] = false;
    }
    else if (fastStorage['ifms-myTask-haschanges']) {
      const doSave = await showGlobalYesNoDialog(
        <div>
          There are unsaved changes. Do you want to save?
        </div>
      ,false, 1, true, 'info');

      const externalFunctions = getExternalFunctions();
      if (doSave) {
        await externalFunctions.ifmsMyTaskSave();
      } else {
        await externalFunctions.ifmsMyTaskCancel();
      }
    }
  }

  async function checkAesAuth(checkSecurity = false): Promise<boolean> {
    if (appContext.user?.isSuntekAdmin) return true;

    if (checkSecurity) {
      const listSec = findSecurityTask(appContext, FmsSecTask.AES);
      if (!listSec.grantRead) {
        await showGlobalOkDialog(<p>please check your user security!!!</p>);
        return false;
      }
    }

    try {
      postal.channel('ajax').publish('ajax.loadingstart', {});

      const statusResult = await appContext.api.getAesAccountStatus();
      if (!statusResult?.result) {
        await showGlobalOkDialog(<p>Please &quot;Create AES Account&quot; first in System Setup</p>);
        return false;
      }
      const accountResult = await appContext.api.checkAesAccount();
      if (!accountResult) {
        await showGlobalOkDialog(<p>Failed to check AES account. Please try again.</p>, false, null, 'warning');
        return false;
      }
      if (!accountResult.success) {
        await showGlobalOkDialog(<p>{accountResult.message ?? 'AES account check failed'}</p>, false, null, 'warning');
        return false;
      }
      if (!accountResult.result) {
        await showGlobalOkDialog(<p>Invalid AES account. Please verify your credentials</p>, false, null, 'warning');
        return false;
      }
      return true;
    } finally {
      postal.channel('ajax').publish('ajax.loadingend', {});
    }
  }

  async function onMenuItemClicked(menuItem:IfmsConfigMenuItem) {
    if (menuItem.disable) return;

    if (menuItem.link && !menuItem.link.includes('http')) await checkStandaloneDirty();
    // if (menuItem.changeOperation) {
    //   if (menuItem.changeOperation === selectedOperation) {
    //     return;
    //   } else {
    //     dispatch(changeOperation(menuItem.changeOperation));
    //   }
    // }
    // AES: 권한 체크를 사이드메뉴 변경 전에 수행
    if (menuItem.name === 'opmenu-aes') {
      const isAesListAlreadyOpen = jobMenu.aes?.some(
        item => item.url.includes('/AESFI/aes') || item.url.includes('/AESL/aes')
      );
      if (!isAesListAlreadyOpen && !await checkAesAuth(true)) return;
    }

    // AI Center: AI Settings 에서 꺼져 있으면 메뉴는 보이되 열지 않는다 — eAWB 미사용과 같은 경고 (2026-10-06)
    if (menuItem.name === 'opmenu-aiCenter' && isAiCenterOff()) {
      await showGlobalOkDialog(<p>{AI_CENTER_CONTACT_SUPPORT}</p>, false, null, 'warning');
      return;
    }

    // ISF: 권한 체크를 사이드메뉴 변경 전에 수행
    if (menuItem.name === 'opmenu-isf' || menuItem.name === 'isf') {
      if (!appContext.user?.isSuntekAdmin) {
        const listSec = findSecurityTask(appContext, FmsSecTask.ISF);
        if (!listSec.grantRead) {
          await showGlobalOkDialog(<p>please check your user security!!!</p>);
          return;
        }
      }
    }

    // AMS : AMS의 권한이 없으면 사이드메뉴 변경 전에 메시지 띄움
    if(menuItem.name === 'opmenu-ams' || menuItem.name === 'ams') {
      if (!appContext.user?.isSuntekAdmin) {
        const canAccess = hasReadableSecurityTask(appContext, FmsSecAmsTasks);
        if(!canAccess){
           await showGlobalOkDialog(<p>please check your user security!!!</p>);
           return;
        } else {
          //sideMenu에서 AMS 메뉴에 접근할 때 권한이 있는 메뉴로 이동하도록 링크 변경
            if(menuItem.name === 'ams') {
              const updateLink = fastStorage['security-ams-menu-link'];
              if(updateLink) menuItem.link = updateLink;
           }
        } 
      }
    }

    if (menuItem.changeOperation) {
      if (menuItem.changeOperation !== selectedOperation) {
        dispatch(changeOperation(menuItem.changeOperation));
      }
    }
    if (menuItem.changeSideMenu) {
      if (menuItem.changeSideMenu !== operationState.sideMenu) {
        dispatch(changeSideMenu(menuItem.changeSideMenu));
      }
    }

    if (menuItem.name === 'amsFiling') {
      // const apiResult = await appContext.api.getAmsLink();
      // const isAmsEnable = !!appContext.suntekSettings?.compliance?.amsId1;

      // if (apiResult && apiResult.success) {
      //   if (isAmsEnable) {
      //     window.open('https://ams1.suntekscm.com/login_auto.aspx?' + apiResult.result);
      //   } else {
      //     window.open('https://ams1.suntekscm.com/login_2017.aspx');  
      //   }
      // } 
      
      // 자동 로그인 기능이도 불필요하다고 해서 자동 로그인 기능 제거
      if(!appContext.user?.isSuntekAdmin) await appContext.api.saveSiteAccessLog(SiteLogType.AmsWeb, 0);
      window.open('https://ams1.suntekscm.com/login_2017.aspx'); 
      return;
    }

    
    if (menuItem.name === 'aciFiling') {
      if(!appContext.user?.isSuntekAdmin) await appContext.api.saveSiteAccessLog(SiteLogType.AciWeb, 0);
      window.open('https://imanifest.suntekscm.com/Home/Login?product=ACI'); 
      return;
    }

    if (menuItem.name === 'isfFiling') {
      const apiResult = await appContext.api.getIsfLink();
      if (apiResult && apiResult.success) {
        //apiResult.result.item2 : auto Login 여부 (1 : true, 0: false)
        if(!appContext.user?.isSuntekAdmin) await appContext.api.saveSiteAccessLog(SiteLogType.IsfWeb, apiResult.result.item2 ? 1 : 0);
        window.open('https://imanifest.suntekscm.com/Home/AutoLoginFms?args=' + apiResult.result.item1);
        return;
      }
    }

    if (menuItem.name === 'aesFiling') {
      if (getSecBySecTask(appContext, FmsSecTask.AES, SecType.Read)) {
        // jobId / jobName 동일한 fallback 흐름: opendOperationData → URL params → 현재 목록/last-selectedId
        let jobId = opendOperationData?.jobParams?.id ?? '';
        let jobName = opendOperationData?.jobName;

        if (!jobId || !jobName) {
          const params = history.location.search.replace('?', '').split('&');
          if (!jobId) {
            jobId = params.find(x => x.includes('id='))?.replace('id=', '') ?? '';
          }
          if (!jobName) {
            jobName = params.find(x => x.includes('jobname='))?.replace('jobname=', '') as JobNames;
          }
        }

        if (!jobId) {
          jobId = document.getElementById('last-selectedId')?.innerText ?? '';
        }
        if (!jobName) {
          jobName = currentListJobName;
        }

        if (parseInt(jobId, 10) && jobName) {
          await runAceFiling({ aceType: "AES", jobId, jobName: jobName });
        }
        return;
      }
    }

    if (menuItem.name === 'eawb') {
        if (!isEawbEnabled(appContext.suntekSettings)) {
          await showGlobalOkDialog(<p>Please contact Suntek for Assistance!</p>, false, null, 'warning');
          return;
        }

        let eawbListJob: JobNames | undefined = opendOperationData?.jobName ?? currentListJobName;
        if (!eawbListJob) {
          const p = history.location.search.replace('?', '').split('&');
          eawbListJob = p.find(x => x.includes('jobname='))?.replace('jobname=', '') as JobNames | undefined;
        }

        // 선택 행(목록 fastStorage)에서 MAWB#/부모 MAWB id 취득.
        const selIndex = Number(document.getElementById('last-selectedIndex')?.innerText ?? '-1');
        const eawbListKey = eawbListJob === JobNames.AEHbl
          ? 'ifms-list-data-/common/joblistview/aeHawb/airExport'
          : 'ifms-list-data-/common/joblistview/aeMawb/airExport';
        const eawbRow = (fastStorage[eawbListKey] && selIndex >= 0) ? fastStorage[eawbListKey][selIndex] : null;

        // jobId fallback: opendOperationData → URL params → last-selectedId
        let eawbJobId = opendOperationData?.jobParams?.id ?? '';
        if (!eawbJobId) {
          const p = history.location.search.replace('?', '').split('&');
          eawbJobId = p.find(x => x.includes('id='))?.replace('id=', '') ?? '';
        }
        if (!eawbJobId) eawbJobId = document.getElementById('last-selectedId')?.innerText ?? '';

        // 원래 선택 행 id — More 메뉴 화면들의 ?jobname=&id= 쿼리 규약용 (AEHbl 은 아래에서 eawbJobId 가 부모 MAWB id 로 바뀜).
        const eawbCtxJobId = eawbJobId;

        // House AWB(AEHbl)에서 열면 선택 행이 HAWB → 부모 MAWB id로 변환 (WinForms AeMblId 대응).
        if (eawbListJob === JobNames.AEHbl) {
          const parentId = eawbRow?.aoMblId ?? eawbRow?.aeMblId ?? eawbRow?.mblId ?? '';
          if (parentId) eawbJobId = String(parentId);
        }

        if (!parseInt(eawbJobId, 10)) {
          // 다른 More Menu(generic 경로)와 동일 문구
          await showGlobalOkDialog(<p>Data is not select!</p>);
          return;
        }

        // 진입 게이트 (WinForms MainForm.nav.cs): MAWB# 길이 + 항공사 prefix 지원 검사. 미통과면 화면 안 열림.
        const eawbMawbNo = (eawbRow?.mawbNo ?? '').toString();
        if (eawbMawbNo) {
          if (eawbMawbNo.length !== 12) {
            await showGlobalOkDialog(<p>MAWB number is invalid.</p>, false, null, 'warning');
            return;
          }
          const brokerType = eawbBrokerType(appContext.suntekSettings); // 3=GLS HK, 4=CCI (계정 id 우선, 데스크톱 EnableEawb 기준과 동일)
          const pr = await appContext.api.getEawbPrefixList(brokerType);
          const prefixes: string[] = (pr && pr.success) ? (pr.entities ?? []) : [];
          // prefix 목록이 있을 때만 미지원 prefix 차단. 목록이 비면(원격 미제공/로드실패) 통과시킨다 —
          // 3.3은 목록이 비면 전부 차단하지만, 로드 실패 시 모든 e-AWB 진입이 막히는 편이 더 나쁘므로 의도적으로 다르게 둠.
          if (prefixes.length > 0 && !prefixes.includes(eawbMawbNo.substring(0, 3))) {
            await showGlobalOkDialog(<p>{`e-AWB provider does not support Air line prefix ${eawbMawbNo.substring(0, 3)}.`}</p>, false, null, 'warning');
            return;
          }
        }

        // FWB/FHL 전송상태는 화면이 EawbController.Load 응답(T_AOMMAIN F_Fwb/F_Fhl)에서 받는다.
        // (예전엔 목록 행 상태를 URL 세그먼트로 넘겼으나 직접 진입·새로고침 시 값이 없어 잘못 표시됨)
        // ?jobname=&id= 쿼리는 다른 More 메뉴 화면과 동일한 규약 — 없으면 CheckMoreMenuJobName 불일치로
        // 이동 직후 사이드 메뉴의 More Menu 그룹이 통째로 사라진다(= 메뉴가 닫혀 보임).
        // AEHbl 진입 시엔 id=HAWB 행 id(More 메뉴 체이닝용) 이므로 부모 MAWB id 를 mid= 로 따로 넘긴다.
        const eawbMidQuery = eawbListJob === JobNames.AEHbl ? `&mid=${eawbJobId}` : '';
        openNewPage(history, `/airExport/eawb?jobname=${eawbListJob}&id=${eawbCtxJobId}${eawbMidQuery}`, NavigationType.newPage);
        return;
    }

    if (menuItem.name === 'inbond') {
        const apiResult = await appContext.api.getInbondLink()
        if (apiResult && apiResult.success) {
            window.open('https://inbond.suntekscm.com/Account/AutoLoginInBondFms?args=' + apiResult.result);
        }
    }

    if (menuItem.name === 'isf10Filing' || menuItem.name === 'isf5Filing') {
      // jobId fallback: opendOperationData → URL params → last-selectedId
      let jobId = opendOperationData?.jobParams?.id ?? '';
      if (!jobId) {
        const params = history.location.search.replace('?', '').split('&');
        jobId = params.find(x => x.includes('id='))?.replace('id=', '') ?? '';
      }
      if (!jobId) {
        jobId = document.getElementById('last-selectedId')?.innerText ?? '';
      }
      const jobType = menuItem.name === 'isf10Filing' ? "10" : "5";
      // This line works only for list, not detail view
      const hblNo = document.getElementById('last-selectedOihblNo')?.innerText??'';
      //<pt260921: Check AmsBlNo, createBy>
      let createByAiAgent = false, amsBlNo = '';
      if(opendOperationData) {
        createByAiAgent = (document.querySelector('input[name="oih-side-create"]') as HTMLInputElement)
          .value.indexOf('@aiagent') >= 0;
        amsBlNo = (document.querySelector('input[name="oih-detail-amsNo"]') as HTMLInputElement)?.value ?? '';
      } else {
        createByAiAgent = (document.getElementById('last-selectedCreateBy')?.innerText??'').indexOf('@aiagent') >= 0;
        amsBlNo = document.getElementById('last-selectedAmsBlNo')?.innerText??'';
      }
      if (parseInt(jobId, 10)) {
        if(createByAiAgent && amsBlNo) {
          //Auto login isf and open isf
          try {
            const csqResult = await apiCallResolver(() => aiapi.get(
              'api/emailjob/isf/shipmentid_by_hblid',
              { 
                params: { hblId: jobId },
                headers: {
                  'ApiKey': getApiKey(),
                  'Content-Type': 'application/json'
                }
              }
            ), true, true);
            let shipmentId = "";
            if(csqResult && csqResult.success) {
              shipmentId = csqResult.data?.result ?? "";
            }
            const apiResult = await appContext.api.getIsfLink('', 0, '', amsBlNo, shipmentId);
            if(apiResult && apiResult.success) {
              if(!appContext.user?.isSuntekAdmin) await appContext.api.saveSiteAccessLog(SiteLogType.IsfWeb, apiResult.result.item2 ? 1 : 0);
              window.open(`${process.env.REACT_APP_IMANIFEST_URL}?args=${apiResult.result.item1}`);
            }
          } catch (error) {
            console.error('Failed to get ISF link:', error);
          }
        } else {
          await runAceFiling({ 
            aceType: "ISF", 
            jobId, 
            jobName: JobNames.OIHbl, 
            jobType,
            hblNo}
          );
        }
      }
      return;
    }
    
    if (menuItem.name === 'isfUpload') {
      const apiResult = await appContext.api.getIsfLink('upload');
      if (apiResult && apiResult.success) {
        //apiResult.result.item2 : auto Login 여부 (1 : true, 0: false)
        if(!appContext.user?.isSuntekAdmin) await appContext.api.saveSiteAccessLog(SiteLogType.IsfWeb, apiResult.result.item2 ? 1 : 0);
        window.open('https://imanifest.suntekscm.com/Home/AutoLoginFms?args=' + apiResult.result.item1);
        return;
      }
    }

    if (menuItem.name === 'isfExcelDownload') {
      const link = document.createElement('a');
      link.href = '/template/Suntek ISF Filing Template.xlsx'; // Relative path to your public file
      link.download = 'Suntek ISF Filing Template.xlsx'; // Suggested filename for download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    if (menuItem.name === 'download') {
      let lastSelectedId = document.getElementById('last-selectedId')?.innerText ?? '';
      if (menuItem.link) {
        if (_.isEmpty(lastSelectedId)) return;

        const parts = menuItem.link.split('/');
        parts[parts.length - 1] = lastSelectedId;
        menuItem.link = parts.join('/');
      }
    }

    if (!!menuItem.link) {
      // if (menuItem.link.indexOf('/releaseOrderTurnover') > 0) {
      //   if (fmsGlobal.NoRelease) {
      //     showGlobalOkDialog('Contact Manager!');
      //     return false;
      //   }
      // }

      if (menuItem.link === history.location.pathname) {
        // The menu item clicked is the same screen we are on. In case it is a list screen, clear filters on that page
        filterChannel.publish('ifms-filter.forceclear');

        // Metadata could be changed. Make sure it is replaced. Both on screen stack and in job menu
        dispatch(replaceJobMenuMetadata({ url: menuItem.link, metadata: menuItem.metadata}));
        dispatch(replaceScreenStackMetadata({url: menuItem.link, metadata: menuItem.metadata}));
      }

      if (menuItem.link.indexOf('parentOp') > -1) {
        if (menuItem.link === history.location.pathname + history.location.search) {
          filterChannel.publish('ifms-filter.forceclear');
        }
        dispatch(replaceJobMenuParentOp({ url: menuItem.link }));
        dispatch(replaceScreenUrlParentOpOnStack({ url: menuItem.link, metadata: menuItem.metadata }));
      }

      // 선택된 레코드 대상 More Menu (링크에 @jobName / @jobid 가 있다). Batch Print 처럼 화면만 여는 메뉴는 아래 일반 링크 처리로 연다
      if (menuItem.moreMenuJobName && menuItem.level !== 0 && menuItem.link.includes('@')) {
      // if (menuItem.moreMenuJobName && menuItem.level === 0) {
        //listSelectedId is Empty
        let lastSelectedId = document.getElementById('last-selectedId')?.innerText ?? '';
        //let jobName = currentListJobName === JobNames.None ? getJobNamesByCurrentUrl(storageKeyMap, activeUrlRef.current) : currentListJobName;
        let jobName = getJobNamesByCurrentUrl(storageKeyMap, activeUrlRef.current) ?? currentListJobName;
        //Click moremenu in moremenu tab
        if (_.isEmpty(lastSelectedId)) {
          const params = history.location.search.replace('?', '').split('&');
          lastSelectedId = params.find(x => x.includes('id='))?.replace('id=', '') ?? '';
          jobName = params.find(x => x.includes('jobname='))?.replace('jobname=', '') as JobNames;

          //Click moremenu in operation detail tab
          if (_.isEmpty(lastSelectedId)) {
            jobName = opendOperationData?.jobName ?? JobNames.None
            //lastSelectedId = document.getElementById(`${opendOperationData?.jobName}-detailid`)?.innerText ?? ''
            lastSelectedId = opendOperationData?.jobParams.id ?? ''
          }
        }

        let link = menuItem.link.replace('@jobName', jobName).replace('@jobid', lastSelectedId);
        const menuText = menuItem.text?.toString()?? "";
        const url = `${window.location.pathname}${window.location.search}`;

        const getMblContext = () => {
          const mblList = jobName === JobNames.OIMbl ? fastStorage[`ifms-list-data-/common/joblistview/mbl/oceanImport`]
            : (jobName === JobNames.OEMbl ? fastStorage[`ifms-list-data-/common/joblistview/oeMbl/oceanExport`]
            : fastStorage[`ifms-list-data-/common/joblistview/aiMawb/airImport`]);
          const selIndex = document.getElementById('last-selectedIndex')?.innerText ?? '-1';
          const editModelKey = jobName === JobNames.OIMbl ? `editOiMbl${lastSelectedId}-/oceanImport/mbl/edit` : `editAiMawb${lastSelectedId}-/airImport/mawb/edit`;
          const viewModelKey = jobName === JobNames.OIMbl ? `viewOiMbl${lastSelectedId}-/oceanImport/mbl/view` : `viewAiMawb${lastSelectedId}-/airImport/mawb/view`;
          const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
          const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
          return { mblList, selIndex, keyMatch, viewKeyMatch };
        };

        if (_.isEmpty(jobName) || _.isEmpty(lastSelectedId)) return;

        // <chuck date="2025-09-23" ticket="250910143" desc="MBL Direct이면 hblArrivalNotice UI로 동작하게 수정.">
        else if (menuText.includes("Arrival Notice") && (jobName === JobNames.OIMbl || jobName === JobNames.AIMbl)) {
          const { mblList, selIndex, keyMatch, viewKeyMatch } = getMblContext();

          if (jobName === JobNames.OIMbl) {
            if (url.includes('/hblArrivalNotice')) return;
            else if ((mblList && Number(selIndex) >= 0 && mblList[selIndex]?.hblCount === 'DBL') || ((keyMatch && fastStorage[keyMatch]?.directBl) || (viewKeyMatch && fastStorage[viewKeyMatch]?.directBl))) {
              link = link.replace('/arrivalNotice?', '/hblArrivalNotice?'); 
              if (!systemSettings?.bl?.changeTitleInAnMenu) {
                menuItem.subMenu = FmsSubMenu.ArrivalNotice;
                setSelectedReportMenuItem(menuItem)
                return;
              }
            }
            else if ((mblList && Number(selIndex) >= 0 && mblList[selIndex]?.hblCount === 'SBL') || ((keyMatch && fastStorage[keyMatch]?.sbl) || (viewKeyMatch && fastStorage[viewKeyMatch]?.sbl))) {
              if (mblList && Number(selIndex) >= 0 && mblList[selIndex]?.hblCount === 'SBL') {
                const apiResult = await appContext.api.getJobDetail(jobName, {id: mblList[selIndex]?.id});
                if (apiResult && apiResult.success) {
                  link = menuItem.link.replace('@jobName', 'OIHB').replace('@jobid', apiResult.result.hblList[0]?.id).replace('/arrivalNotice?', '/hblArrivalNotice?').replace('&isAtme=false', ''); 
                }
              }
              else if (keyMatch && fastStorage[keyMatch].sbl) {
                link = menuItem.link.replace('@jobName', 'OIHB').replace('@jobid', fastStorage[keyMatch].hblList[0]?.id).replace('/arrivalNotice?', '/hblArrivalNotice?').replace('&isAtme=false', ''); 
              }
              else if (viewKeyMatch && fastStorage[viewKeyMatch].sbl) {
                link = menuItem.link.replace('@jobName', 'OIHB').replace('@jobid', fastStorage[viewKeyMatch].hblList[0]?.id).replace('/arrivalNotice?', '/hblArrivalNotice?').replace('&isAtme=false', ''); 
              }

              if (!systemSettings?.bl?.changeTitleInAnMenu) {
                menuItem.subMenu = FmsSubMenu.ArrivalNotice;
                setSelectedReportMenuItem(menuItem)
                return;
              }
            }
          }
          else {
            if (url.includes('/hblArrivalNotice')) return;
            else if ((mblList && Number(selIndex) >= 0 && mblList[selIndex]?.hblStat === 'DBL') || ((keyMatch && fastStorage[keyMatch]?.directBL) || (viewKeyMatch && fastStorage[viewKeyMatch]?.directBL))) {
              link = link.replace('/arrivalNotice?', '/hblArrivalNotice?'); 
              if (!systemSettings?.bl?.changeTitleInAnMenu) {
                menuItem.subMenu = FmsSubMenu.ArrivalNotice;
                setSelectedReportMenuItem(menuItem)
                return;
              }
            }
            else if ((mblList && Number(selIndex) >= 0 && mblList[selIndex]?.hblStat === 'SBL') || ((keyMatch && fastStorage[keyMatch].sbl) || (viewKeyMatch && fastStorage[viewKeyMatch].sbl))) {
              if (mblList && Number(selIndex) >= 0 && mblList[selIndex]?.hblStat === 'SBL') {
                const apiResult = await appContext.api.getJobDetail(jobName, {id: mblList[selIndex]?.id});
                if (apiResult && apiResult.success) {
                  link = menuItem.link.replace('@jobName', 'AIHB').replace('@jobid', apiResult.result.hblList[0]?.id).replace('/arrivalNotice?', '/hblArrivalNotice?'); 
                }
              }
              else if (keyMatch && fastStorage[keyMatch].sbl) {
                link = menuItem.link.replace('@jobName', 'AIHB').replace('@jobid', fastStorage[keyMatch].hblList[0]?.id).replace('/arrivalNotice?', '/hblArrivalNotice?'); 
              }
              else if (viewKeyMatch && fastStorage[viewKeyMatch].sbl) {
                link = menuItem.link.replace('@jobName', 'AIHB').replace('@jobid', fastStorage[viewKeyMatch].hblList[0]?.id).replace('/arrivalNotice?', '/hblArrivalNotice?'); 
              }

              if (!systemSettings?.bl?.changeTitleInAnMenu) {
                menuItem.subMenu = FmsSubMenu.ArrivalNotice;
                setSelectedReportMenuItem(menuItem)
                return;
              }
            }
          }
        }
        // </chuck>
        else if (menuText.includes("Pickup/Delivery Instruction") && (jobName === JobNames.OIMbl || jobName === JobNames.OEMbl || jobName === JobNames.AIMbl)) {
          const { mblList, selIndex, keyMatch, viewKeyMatch } = getMblContext();

          const hblJobName = jobName === JobNames.OIMbl ? 'OIHB' : (jobName === JobNames.OEMbl ? 'OEHB' : 'AIHB');

          if (url.includes(jobName === JobNames.OIMbl ? "hbl" : (jobName === JobNames.OEMbl ? "oeHbl" : "aiHawb"))) return;
          else if (mblList && Number(selIndex) >= 0 && (jobName === JobNames.AIMbl ? mblList[selIndex]?.hblStat === 'SBL' : mblList[selIndex]?.hblCount === 'SBL')) {
            const apiResult = await appContext.api.getJobDetail(jobName, {id: mblList[selIndex]?.id});
            if (apiResult && apiResult.success) {
              link = menuItem.link.replace('@jobName', hblJobName).replace('@jobid', apiResult.result.hblList[0]?.id);
            }
          }
          else if (keyMatch && fastStorage[keyMatch].sbl) {
            link = menuItem.link.replace('@jobName', hblJobName).replace('@jobid', fastStorage[keyMatch].hblList[0]?.id);
          }
          else if (viewKeyMatch && fastStorage[viewKeyMatch].sbl) {
            link = menuItem.link.replace('@jobName', hblJobName).replace('@jobid', fastStorage[viewKeyMatch].hblList[0]?.id);
          }
        }
        
        if (lastSelectedId === '0' && menuItem.moreMenuJobName === jobName && !menuItem.link.includes('/common/deleteHistory')) {
          await showGlobalOkDialog(<p>Data is not select!</p>);
        } else {
          openNewPage(history, link, NavigationType.newPage, menuItem.metadata);
        }

        return;
      }

      if (menuItem.link?.includes('http'))
        window.open(menuItem.link);
      else
        openNewPage(history, menuItem.link, NavigationType.newPage, menuItem.metadata);
    }

    if (!!menuItem.popupComponent) {
      if (menuItem.name === 'cfsRelease') {
        let jobId = opendOperationData?.jobParams?.id ?? '';
        if (!jobId) {
          const params = history.location.search.replace('?', '').split('&');
          jobId = params.find(x => x.includes('id='))?.replace('id=', '') ?? '';
        }
        if (!jobId) {
          jobId = document.getElementById('last-selectedId')?.innerText ?? '';
        }

        let rlsStat = !opendOperationData ? (document.getElementById('last-selectedRlsStat')?.innerText ?? '') : '';
        if (rlsStat === '')
          rlsStat = await appContext.api.getFieldValue({ id: jobId, tableName: 'T_OIHMAIN', fieldName: 'F_RLSDate' }) === '' ? 'N' : 'Y';

        const apiResult = await appContext.api.checkReleaseOrder(jobId);
        if (apiResult && apiResult.success) {
          const opt = apiResult.result as CFSManifestReleaseOption;
          if (opt === null || !opt.requestDept || !opt.email)
            await showGlobalOkDialog(<p>CFS/Contact not configured for email release.<br></br>
              (Name='ediRelease', Dept=NVOID, EMail=Address)</p>);
          else {
            // var rlsYN = jobListView.ListRenderer.OihCellClickHandler("RlsStat", oihListItem); 
            if (rlsStat === 'Y') {
              const doSave = await showGlobalYesNoDialog(
                <div>
                  Do you want to release?
                </div>
                , false, 0, true, 'info');

              if (doSave) { //EDI 메일폼열기
                const vContents = await appContext.api.makeCfsRelease({ id: +jobId, contact: opt.contact, requestDept: opt.requestDept })
                viewEmptyReport(false, opt.companyId.toString(), 'Release', vContents?.message ?? '', 'T_OIHMAIN', +jobId);
              }
            }
            else {
              menuItem.popupComponent =
                <HblReleasePopup hblId={+jobId}
                  storageKey={''} onClose={function (x: ReleaseHblInfo | null): void {
                    const storageKey = `oih-hblrls-${jobId}`;
                    fastStorage[storageKey] = null;
                    setSelectedPopupMenuItem(null);
                  }} isView={false} fromCFS={true}
                />;
              setSelectedPopupMenuItem(menuItem)
            }
          }
        }
      } else if (menuItem.name === 'bankEDI') {
        let jobId = '';
        if (!!opendOperationData) {
          jobId = opendOperationData?.jobParams?.id;
        }
        menuItem.popupComponent =
          <BankEdi jobName={JobNames.BillPayment} selectedElementId={+jobId} />;
        setSelectedPopupMenuItem(menuItem)
      }
      //Period Close가 사용되고 있음
      else setSelectedPopupMenuItem(menuItem)
    }

    if (!!menuItem.subMenu || !!menuItem.subMenuNonReport) {
      setSelectedReportMenuItem(menuItem)
    } 

    //Move to ifmsHelp.tsx
    //for HelpButton 
    if (operationState.sideMenu === constants.operations.utility) {
      if (menuItem.text?.toString() === 'Check File Server')
        checkFileServer();
      else if (menuItem.text?.toString().includes('B/L Activity Status')) {
        menuItem.text.toString().includes('OIH') ? setMilestoneOption('OIH') : setMilestoneOption('AIH');
      }
      else if (menuItem.text?.toString() === 'eSupport') {
        openESupportPage();
      }
    }

    if (operationState.sideMenu === constants.operations.accounting) {
      if (menuItem.text?.toString() === 'iXpense')
        return;
      //await showGlobalOkDialog(<p>Please Contact Suntek to Activate</p>);
    }
  }

  async function getSelectedElement(model: any) {
    if (model) {
      if (listData && listData.length > 0) {
        return listData?.find((x: any) => String(x.id) === listSelectedId) as typeof model;
      }
    }
    else {
      //Click moremenu in moremenu tab
      const params = history.location.search.replace('?', '').split('&');
      let jobName = params.find(x => x.includes('jobname='))?.replace('jobname=', '') as JobNames;
      let jobId = params.find(x => x.includes('id='))?.replace('id=', '') ?? '';

      let job = null;
      let listView = null;


      model = getListItemByJobName(jobName);

      if (!model) {//Click moremenu in operation detail tab
        jobName = opendOperationData?.jobName ?? JobNames.None;
        jobId = opendOperationData?.jobParams?.id ?? 0;

        if(!jobName && !jobId) return;

        model = getListItemByJobName(jobName);
        //Operation Menu의 List가 켜져있지 않은 상태에서 Detail View에 접근 후 Report Menu Click시 Report가 표시되지 않는 문제 수정
        job = getJobFromName(jobName);
        listView = job.generateListView();
      }

      const listData = fastStorage[`ifms-list-data-${storageKeyMap.get(jobName)}`];
      if (listData) {
        return listData?.find((x: any) => String(x.id) === jobId) as typeof model ?? model;
      } else {
        //Operation Menu의 List가 켜져있지 않은 상태에서 Detail View에 접근 후 Report Menu Click시 Report가 표시되지 않는 문제 수정
        if (listView) {
          const data = await listView.fetchAndFormatData(appContext.api, { ...getInitialSearch(), ...{ general1: 'id', generalText1: jobId ?? '', pageSize: listViewPageSize, pagePerBatch: listViewPagePerBatch } }, 1, listViewPageSize * listViewPagePerBatch, undefined, appContext.user, jobListContext);
          // console.log(data);
          return data.data?.find((x: any) => String(x.id) === jobId) as typeof model ?? model;
        }
      }
      return model;
    }
  }

  async function onSubMenuClick (fmsSubMenu: FmsSubMenu, model: any, jobName: JobNames) {
    setSelectedReportMenuItem(null);
    if (!jobName) {
      // 리스트가 아니면 상세화면 → More 탭(URL 의 jobname=) 순으로 Job 을 찾는다
      jobName = opendOperationData?.jobName
        ?? (new URLSearchParams(history.location.search).get('jobname') as JobNames | null)
        ?? JobNames.None;
    }
    let fullLink = '';
    let selectedElement;

    if (fmsSubMenu == FmsSubMenu.CustomerPayList || fmsSubMenu == FmsSubMenu.BillPayList) {
      fullLink = `/common/joblistview/${fmsSubMenu == FmsSubMenu.CustomerPayList ? 'acCustomerPayment' : 'acBillPayment'}/accounting`;

      openNewPage(history, fullLink, NavigationType.newPage);
      return;
    }

    if ([JobNames.OpInvoice, JobNames.Invoice, JobNames.GInvo, JobNames.WHInvoice, JobNames.WHStorageInv,
        JobNames.OpBill, JobNames.Bill, JobNames.GBill, JobNames.WHBill, 
        JobNames.OpCrDb, JobNames.CrDb, JobNames.WHCrDb].includes(jobName as JobNames)) {
      selectedElement = await getSelectedElement(model);
      if (!selectedElement) {
        return;
      }
    }

    if (fmsSubMenu == FmsSubMenu.NewCustomerPay || fmsSubMenu == FmsSubMenu.NewBillPay || 
        fmsSubMenu == FmsSubMenu.CustomerStatement || fmsSubMenu == FmsSubMenu.AgentStatement) {
    //if(opendOperationData) return;

      // let link = `/accounting/${fmsSubMenu == FmsSubMenu.NewCustomerPay ? 'acCustomerPayment' : 'acBillPayment'}/add`;
      let linkId = 0;
      switch (jobName) {
        case JobNames.OpInvoice:
        case JobNames.Invoice:
        case JobNames.GInvo:
          // fullLink = `${link}/${selectedElement.invoiceTo}`;
          linkId = selectedElement.invoiceTo;
          break;
        case JobNames.OpBill:
        case JobNames.Bill:
        case JobNames.GBill:
          // fullLink = `${link}/${selectedElement.vendorId}`;
          linkId = selectedElement.vendorId;
          break;
        case JobNames.OpCrDb:
        case JobNames.CrDb:
          // fullLink = `${link}/${selectedElement.agentId}`;
          linkId = selectedElement.agentId;
          break;
        // OI
        case JobNames.OIMbl:
        case JobNames.OIHbl:
        case JobNames.OIContainer:
        case JobNames.OIQuotation:
        case JobNames.OILoad:
        case JobNames.OIVessel:
        case JobNames.OIMPims:
        case JobNames.OIHPims:
        // OE
        case JobNames.OEMbl:
        case JobNames.OEHbl:
        case JobNames.OEBook:
        case JobNames.OEContainer:
        case JobNames.OEQuotation:
        case JobNames.OELoad:
        case JobNames.OEMPims:
        case JobNames.OEHPims:
        // AI
        case JobNames.AIMbl:
        case JobNames.AIHbl:
        case JobNames.AIQuotation:
        case JobNames.AIMPims:
        case JobNames.AIHPims:
        // AE
        case JobNames.AEMbl:
        case JobNames.AEHbl:
        case JobNames.AEQuotation:
        case JobNames.AEMPims:
        case JobNames.AEHPims:
        // OT
        case JobNames.OtherOP:
        case JobNames.OtherContainer:
        case JobNames.OtQuotation:
        default:
          // fullLink = `${link}/0`;
          linkId = 0;
          break;
      }

      switch(fmsSubMenu) {
        case FmsSubMenu.NewCustomerPay:
          fullLink = `/accounting/acCustomerPayment/add/${linkId}`;
          break;
        case FmsSubMenu.NewBillPay:
          fullLink = `/accounting/acBillPayment/add/${linkId}`;
          break;
        case FmsSubMenu.CustomerStatement:
          fullLink = `/accounting/acCustomerStatement?parentOp=billings&id=${linkId}`;
          break;
        case FmsSubMenu.AgentStatement:
          fullLink = `/accounting/acAgentStatement?parentOp=billings&id=${linkId}`;
          break;
      }

      moveToSingleOpenedScreenInAnyOperationStartingWithUrl(fullLink, [fullLink], false, true);
      return;
    }

    if (fmsSubMenu === FmsSubMenu.SwitchJournal) {
    //if(opendOperationData) return;
      switch (jobName) {
        case JobNames.OpInvoice:
        case JobNames.Invoice:
          switchJournal(JobNames.Invoice, selectedElement.id);
          break;
        case JobNames.GInvo:
          switchJournal(JobNames.GInvo, selectedElement.id);
          break;
        case JobNames.OpBill:
        case JobNames.Bill:
          switchJournal(JobNames.Bill, selectedElement.id);
          break;
        case JobNames.GBill:
          switchJournal(JobNames.GBill, selectedElement.id);
          break;
        case JobNames.OpCrDb:
        case JobNames.CrDb:
          switchJournal(JobNames.CrDb, selectedElement.id)

          break;
      } 
      return;
    } 

    // if (fmsSubMenu === FmsSubMenu.OpenHistoryView || fmsSubMenu === FmsSubMenu.OpenDeleteHistoryView) {
    //   const viewAcctDeleteHistory = fmsSubMenu === FmsSubMenu.OpenDeleteHistoryView;
    //   let width = 1200;

    //   if (viewAcctDeleteHistory || [JobNames.OpBill, JobNames.Bill, JobNames.GBill].includes(jobName))
    //     width = 920;

    //   if (viewAcctDeleteHistory) width = 640;

    //   let deleteTitle = "";
    //   switch (jobName) {
    //     case JobNames.Invoice:  deleteTitle = "Invoice"; break;
    //     case JobNames.Bill:  deleteTitle = "Bill"; break;
    //     case JobNames.CrDb:  deleteTitle = "CrDb"; break;
    //     case JobNames.GInvo:  deleteTitle = "G. Invoice"; break;
    //     case JobNames.GBill:  deleteTitle = "G. Bill"; break;
    //   }

    //   setSelectedReportPopupMenuItem({ 
    //     label: fmsSubMenu === FmsSubMenu.OpenHistoryView ? 'View History' : 'Delete History (' + deleteTitle + ')',
    //     popupWidth: width,
    //     popupTop: fmsSubMenu === FmsSubMenu.OpenHistoryView ? 0 : 50,
    //     popupComponent: (<HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={jobName} onPopupClose={() => setSelectedReportPopupMenuItem(null)} viewDeleteHistory={viewAcctDeleteHistory} />)
    //   });
    //   return;
    // }

    if (fmsSubMenu === FmsSubMenu.OpenHistoryView) {
      if (!selectedElement) return;

      let width = 1225;

      if ([JobNames.OpBill, JobNames.Bill, JobNames.GBill, JobNames.WHBill].includes(jobName))
        width = 945;

      let deleteTitle = "";
      switch (jobName) {
        case JobNames.Invoice:  deleteTitle = "Invoice"; break;
        case JobNames.Bill:     deleteTitle = "Bill"; break;
        case JobNames.CrDb:     deleteTitle = "CrDb"; break;
        case JobNames.GInvo:    deleteTitle = "G. Invoice"; break;
        case JobNames.GBill:    deleteTitle = "G. Bill"; break;

        case JobNames.WHInvoice: 
        case JobNames.WHStorageInv: 
          jobName = JobNames.Invoice;
          deleteTitle = "Invoice"; 
          break;
        case JobNames.WHBill: 
          jobName = JobNames.Bill;
          deleteTitle = "Bill"; 
          break;
        case JobNames.WHCrDb: 
          jobName = JobNames.CrDb;
          deleteTitle = "CrDb"; 
          break;
      }
      
      setSelectedReportPopupMenuItem({ 
        label: `View History (${deleteTitle})`,
        popupWidth: width,
        popupTop: fmsSubMenu === FmsSubMenu.OpenHistoryView ? 0 : 50,
        popupComponent: (<HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={jobName} onPopupClose={() => setSelectedReportPopupMenuItem(null)} />)
      });
      return;
    }

    if (fmsSubMenu === FmsSubMenu.PrintBill) {
      if (!selectedElement) return;

      setSelectedReportPopupMenuItem({
        label: 'Print Bill',
        popupWidth: 540,
        popupComponent: (<PrintBill selectedElement={selectedElement} onPopupClose={() => setSelectedReportPopupMenuItem(null)} />)
      });
      return;
    }

    if (fmsSubMenu === FmsSubMenu.BatchPrint) {
      openNewPage(history, '/accounting/batchPrint/invoice/add', NavigationType.newPage);
      return;
    }

    if (fmsSubMenu === FmsSubMenu.ViewPaymenHistory) {

      let link = `/accounting/acPaymentHistoryView`;

      switch (jobName) {
        case JobNames.OpInvoice:
        case JobNames.Invoice:
          fullLink = `${link}/INVO/${selectedElement.id}?parentOp=billings`;
          break;
        case JobNames.OpBill:
        case JobNames.Bill:
          fullLink = `${link}/BILL/${selectedElement.id}?parentOp=billings`;
          break;
        case JobNames.OpCrDb:
        case JobNames.CrDb:
          fullLink = `${link}/CRDB/${selectedElement.id}?parentOp=billings`;
          break;
        case JobNames.GInvo:
          fullLink = `${link}/GINVE/${selectedElement.id}?parentOp=billings`;
          break;
        case JobNames.GBill:
          fullLink = `${link}/GBILE/${selectedElement.id}?parentOp=billings`;
          break;
      }

      moveToSingleOpenedScreenInAnyOperationStartingWithUrl(fullLink, [fullLink]);
      return;
    }

    if (fmsSubMenu === FmsSubMenu.AesEei || fmsSubMenu === FmsSubMenu.AesResponse
      || fmsSubMenu === FmsSubMenu.AesSite || fmsSubMenu === FmsSubMenu.AesUsageReport) {
      const isAesListAlreadyOpen = jobMenu.aes?.some(
        item => item.url.includes('/AESFI/aes') || item.url.includes('/AESL/aes')
      );
      if (!isAesListAlreadyOpen && !await checkAesAuth()) return;

      if (fmsSubMenu === FmsSubMenu.AesEei || fmsSubMenu === FmsSubMenu.AesResponse) {
        const jobId = listSelectedId || opendOperationData?.jobParams?.id;
        if (!jobId) {
          await showGlobalOkDialog(<p>Please select an AES item first.</p>);
          return;
        }
        const reportType = fmsSubMenu === FmsSubMenu.AesEei ? 'EEI' : 'Response';
        try {
          const apiResult = await appContext.api.printAes(+jobId, reportType);
          if (apiResult?.success) {
            const newWindow = window.open();
            if (newWindow) {
              const iframe = document.createElement("iframe");
              iframe.src = "data:application/pdf;base64," + apiResult.result;
              iframe.style.cssText = "border:0;width:100%;height:100%";
              newWindow.document.title = reportType === "EEI"
                ? "Electronic Export Information Report"
                : "AES Response Report";
              newWindow.document.body.style.margin = "0";
              newWindow.document.body.appendChild(iframe);
              newWindow.document.close();
            }
          } else {
            await showGlobalOkDialog(<p>{apiResult?.message ?? 'Print failed'}</p>);
          }
        } catch (error) {
          console.error("Print failed:", error);
        }
        return;
      }

      if (fmsSubMenu === FmsSubMenu.AesSite) {
        const loginUrlResult = await appContext.api.getAesLoginUrl();
        if (loginUrlResult?.result) {
          window.open(loginUrlResult.result);
        }
        return;
      }

      if (fmsSubMenu === FmsSubMenu.AesUsageReport) {
        setSelectedReportPopupMenuItem({
          label: 'AES Usage Report',
          popupWidth: 500,
          popupComponent: (<AesUsageReportView onPopupClose={() => setSelectedReportPopupMenuItem(null)} />)
        });
        return;
      }
    }

    if (fmsSubMenu === FmsSubMenu.AutoBillingView) {
      setSelectedReportPopupMenuItem({
        label: 'Auto Billing',
        popupWidth: 860,
        popupComponent: (<AutoBilling  onPopupClose={() => setSelectedReportPopupMenuItem(null)} />)
      });
      return;
    }

    // if (fmsSubMenu === FmsSubMenu.AutoBillingView) {
    //  let link = `/accounting/acAutobilling?parentOp=billings`;
    //   switch (jobName) {
    //     case JobNames.GInvo:
    //       fullLink = `${link}`;
    //       break;
    //   }

    //   moveToSingleOpenedScreenInAnyOperationStartingWithUrl(fullLink, [fullLink]);
    //   return;
    // }

  }

  async function onReportMenuClick(fmsSubMenu: FmsSubMenu, model: any, jobName: JobNames) {
    setSelectedReportMenuItem(null);
    // AES items are handled by onSubMenuClick (via subMenuNonReport), not here
    if (fmsSubMenu === FmsSubMenu.AesEei || fmsSubMenu === FmsSubMenu.AesResponse
      || fmsSubMenu === FmsSubMenu.AesSite || fmsSubMenu === FmsSubMenu.AesUsageReport) {
      return;
    }
    const selectedElement = await getSelectedElement(model);
    if (!selectedElement) {
      return;
    }

    if (fmsSubMenu === FmsSubMenu.AesOcean || fmsSubMenu === FmsSubMenu.AesAir || fmsSubMenu === FmsSubMenu.AesOtherOP) {
      if (fmsSubMenu === FmsSubMenu.AesOcean) {
        if (!selectedElement.hblNo) {
          await showGlobalOkDialog(<p>No Hbl Number exist!</p>);
          return;
        }
      }
      else { 
        if (fmsSubMenu !== FmsSubMenu.AesOtherOP) {
          if (!selectedElement.hawbNo) {
            await showGlobalOkDialog(<p>No Hbl Number exist!</p>);
            return;
          }
        }
      }
      if (!(getFmsGlobal().PimsID)) {
        await showGlobalOkDialog(<p>CANNOT CONNECT DB SERVER!</p>);
        return;
      }

      var apiResult = await appContext.api.getAesLink();

      if (apiResult && apiResult.success) {
        window.open('https://aes.suntekscm.com/home/loginrequest/' + apiResult.result);
      }
      return; 
    }

    let tempJobName = jobName;
    if (!tempJobName) { //Click moremenu in moremenu tab
      const params = history.location.search.replace('?', '').split('&');
      tempJobName = params.find(x => x.includes('jobname='))?.replace('jobname=', '') as JobNames;
      if (!tempJobName) //Click moremenu in operation detail tab
        tempJobName = opendOperationData?.jobName ?? JobNames.None;;
    }

    // 250623.inhyung. Customer List >> Email에서 Memo 클릭시 생기는 오류 수정.
    if (fmsSubMenu === FmsSubMenu.SendEmail) {
      viewEmptyReport(false, selectedElement.id.toString(),'','','T_COMPANY',selectedElement.id);
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, tempJobName, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if (args) {
      viewReport(args, "", true);
    }
  }

  function closeGlobalOk() {
    if (globalOkDialog.resolve) {
      globalOkDialog.resolve();
    }
    dispatch(hideGlobalOkDialog());

    const currentCellSelection = document.querySelector('.data-cell-selected') as HTMLElement;
    if (currentCellSelection) {
      let parent: HTMLElement | null = currentCellSelection.parentElement;
      let tableId: string | null = null;
      let tableEle: HTMLElement | null = null;
      while (parent && !tableId) {
        if (parent.getAttribute('role') === 'table') {
          tableId = parent.id;
          tableEle = document.getElementById(tableId);
          break;
        }
        parent = parent.parentElement;
      }
      setFocusEleAfterModalOkBtnClick(tableEle);
    }
    else {
      const focusedElementIndexInStorage = fastStorage[`focusedEleIndexCurPageInStorage-${currentUrl}`];
      setFocusEleAfterModalOkBtnClick(getTabableElementByIndex(focusedElementIndexInStorage));
    }
  }

  function noMenus() {
    const hasJob = !!menus && !!menus.job && menus.job.length > 0;
    const hasReport = !!menus && !!menus.report && menus.report.length > 0;
    const hasPreReport = !!menus && !!menus.preReport && menus.preReport.length > 0;
    const hasOperationReport = !!menus && !!menus.operationReport && menus.operationReport.length > 0;
    const hasMoreMenu = !!menus && !!menus.moreMenu && menus.moreMenu.length > 0;

    return !hasJob && !hasReport && !hasPreReport && !hasOperationReport && !hasMoreMenu;
  }

  function getPopUpCompent(selectedPopupMenuItem: any, menuModel: any) {
    if (menuModel === undefined)
      return cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose, updateSelectedPopupMenuItemWidth })
    else
      return cloneElement(selectedPopupMenuItem.popupComponent!, {
        onPopupClose, updateSelectedPopupMenuItemWidth,
        selectedElement: async () => { const result = await getSelectedElement(menuModel); return result; },
        selectedElementId: async () => { const result = await getSelectedElement(menuModel); return result.id; }
      })
  }

  if (!initialized) {
    return null;
  }

  function CheckMoreMenuJobName(moreMenuJobName: JobNames | undefined) {
    return currentListJobName === moreMenuJobName //ListView
      || history.location.search.includes(`jobname=${moreMenuJobName}`) //Moremenu Tab
      || (opendOperationData?.jobName === moreMenuJobName); //Operation detail tab
      //|| moreMenuJobName === JobNames.OtherOP;
  }

  function GetMoreMenuJobName(currentUrl: string) {
    const jobNameIndex = currentUrl.indexOf('jobname=');
    if (currentUrl.includes('&')) return currentUrl.substring(jobNameIndex + 8, currentUrl.indexOf('&', jobNameIndex));
    else return currentUrl.substring(jobNameIndex + 8);
  // return currentListJobName === moreMenuJobName //ListView
    //   || history.location.search.includes(`jobname=${moreMenuJobName}` ?? '') //Moremenu Tab
    //   || (opendOperationData?.jobName === moreMenuJobName); //Operation detail tab
  }
  // const systemMenus = _.cloneDeep(config.systemMenus);
  // if (!systemSettings.enableBranch) {
  //   if (systemMenus[0] && systemMenus[0].items && systemMenus[0].items[0]) {
  //     const originalItems = systemMenus[0].items[0].items ?? [];
  //     systemMenus[0].items[0].items = originalItems.filter(x => x.text !== 'Branch');
  //   }
  // }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }
  
  const onReportPopupClose = () => {
    setSelectedReportPopupMenuItem(null);
  }

  const updateSelectedPopupMenuItemWidth = (popupWidth: number) => {
    setSelectedPopupMenuItem((item) => {
      if(item) {
        item.popupWidth = popupWidth;
        return {...item}
      }
      return null;
    })
  }

  const hasSideMenu = !!menus && !noMenus() && !isHome;

  return (
    <div id="ifms-app" tabIndex={-1}>
      <JobSwitchingMenuContext.Provider value={{
        context: jobMenuContextState,
        setInContext: setInJobMenuContext,
        resetForCurrentJob: resetJobMenuContextState,
        isHome,
        hasSideMenu,
      }}>
        <div id="ifms-top-bar">
          <IfmsTopBar
            onMenuItemClicked={onMenuItemClicked}
            systemSettings={systemSettings}
            selectedOperation={operationState.sideMenu}
            menus={menus}
            currentUrl={`${history.location.pathname}${history.location.search}`}
            openNewPage={link => openNewPage(history, link, NavigationType.newPage)}
            logout={logoutUser}
            user={userLogin.user}
          />
          <JobSwitchingMenu resetJobMenuContextState={resetJobMenuContextState} />
        </div>
        <div id="ifms-app-route-container" style={{ height: `calc(100% - ${topBarHeight}px)`, top: `${topBarHeight}px`, display: 'flex' }}>
          {hasSideMenu &&
            <div id="side-menu-operations-parent" style={{ position: 'fixed', height: `calc(100% - ${topBarHeight}px)`, zIndex: 998 }}>
              <IfmsSideMenu
                parentId="side-menu-operations-parent"
                menuId="side-menu-operations"
                menus={menus}
                onMenuItemClicked={onMenuItemClicked}
                operation={operationState.sideMenu}
                opendOperationData={opendOperationData}
              />
            </div>
          }

          <div style={{ marginLeft: `${marginWidth}`, width: `calc(100% - ${marginWidth})` }}>
            <div id="ifms-app-content" style={{ height: '100%' }}>
              <React.Suspense fallback={<div></div>}>
                {routes}
              </React.Suspense>
              <AIDropZone onToast={push} onNavigate={onNavigate} />
              <ToastContainer toasts={toasts} onDismiss={dismiss} onNavigate={onNavigate}  />
            </div>
          </div>
        </div>

        <Modal
          isOpen={globalYesNoCancelDialog.show}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel=""
          style={{
            overlay: ModalOverlayStyle,
            content: ModalContentStyle
          }}
        >
          <div style={{ position: 'relative' }}>
            <button
              onClick={() => {
                if (globalYesNoCancelDialog.resolve) {
                  globalYesNoCancelDialog.resolve(YesNoCancelResult.Cancel);
                }
                dispatch(hideGlobalYesNoCancelDialog());
              }}
              style={{
                position: 'absolute',
                top: '-15px',
                right: '0px',
                background: 'none',
                border: 'none',
                fontSize: '20px',
                cursor: 'pointer',
                color: '#666',
                width: '30px',
                height: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}            
              aria-label="Close modal"
            >
              ×
            </button>
          </div>
          <div id='global-yesNoCancelDialog' className="global-dialog-content" style={{ whiteSpace: 'pre' }}>
          <LeftRightSplit
                leftSize='40px'
                rightSize='calc(100% - 40px)'
                left={
                  <>
                    <img src={NoticeWarningIcon} style={{ height: 32, width: 32 }} alt="" /> 
                  </>
                }
                right={<div style={{marginTop:'4px'}}>
                  {globalYesNoCancelDialog.content}</div>
                }
            />
          </div>
          <ButtonGroup
            customClass="ifms-dialog-button"
            buttons={['Yes', 'No']}
            onButton={b => {
              if (globalYesNoCancelDialog.resolve) {
                if (b === 'Yes') {
                  globalYesNoCancelDialog.resolve(YesNoCancelResult.Yes);
                } else if (b === 'No') {
                  globalYesNoCancelDialog.resolve(YesNoCancelResult.No);
                }
              }
              dispatch(hideGlobalYesNoCancelDialog());
            }}
            defaultFocusIndex={globalYesNoCancelDialog.focusindex}
          />
        </Modal>

        <Modal
          isOpen={globalYesNoDialog.show}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel=""
          style={{
            overlay: ModalOverlayStyle,
            content: ModalDialogContentStyle
          }}
        >
          <div id='global-yesNoDialog' className="global-dialog-content" style={{ whiteSpace: 'pre' }}>
          <LeftRightSplit
                leftSize='40px'
                rightSize='calc(100% - 40px)'
                left={
                  <>
                    <img src={NoticeYesNoIcon} style={{ height: 32, width: 32, display: globalYesNoDialog.inform }} alt="" /> 
                    <img src={NoticeWarningIcon} style={{ height: 32, width: 32, display: globalYesNoDialog.warning }} alt="" /> 
                  </>
                }
                right={<div style={{marginTop:'4px'}}>
                  {globalYesNoDialog.content}</div>
                }
            />
          </div>
          <ButtonGroup
            customClass={(globalYesNoDialog.invert || globalYesNoDialog.addor) ? "ifms-dialog-button ifms-dialog-button-yesorno" : "ifms-dialog-button"}
            buttons={globalYesNoDialog.invert ? ['No', 'Yes'] : ['Yes', 'No']}
            onButton={b => {
              if (globalYesNoDialog.resolve) {
                if (b === 'Yes') {
                  globalYesNoDialog.resolve(true);
                } else {
                  globalYesNoDialog.resolve(false);
                }
              }
              dispatch(hideGlobalYesNoDialog());
            }}
            //defaultFocusIndex={globalYesNoDialog.focusindex > 0 ? globalYesNoDialog.focusindex : 0}
            defaultFocusIndex={globalYesNoDialog.focusindex}
            addOr={globalYesNoDialog.addor}
          />
        </Modal>
        <Modal
          isOpen={globalOkDialog.show}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel=""
          style={{
            overlay: ModalOverlayStyle,
            content: globalOkDialog.top
              ? { ...ModalDialogContentStyle, top: globalOkDialog.top, transform: 'translate(-50%)', }
              : ModalDialogContentStyle
          }}
        >
          <div id='global-okDialog' className="global-dialog-content" style={{ whiteSpace: 'pre' }}>
            <LeftRightSplit
                leftSize='40px'
                rightSize='calc(100% - 40px)'
                left={
                  <div>
                  <img src={NoticeOKIcon} style={{ height: 32, width: 32, display: globalOkDialog.inform }} alt="" /> 
                  <img src={NoticeWarningIcon} style={{ height: 32, width: 32, display: globalOkDialog.warning }} alt="" /> 
                  <img src={NoticeErrorIcon} style={{ height: 32, width: 32, display: globalOkDialog.error }} alt="" /> 
                  </div>
                }
                right={
                <div style={{marginTop:'4px'}}>
                  {globalOkDialog.content}
                </div>
                }
            />
          </div>
          {!globalOkDialog.hideOkButton &&
            <OkButton
             // customClass="ifms-dialog-button"
              onOk={closeGlobalOk}
              customClass="ifms-dialog-button ifms-dialog-button-ok"
            />
          }
        </Modal>
        <GlobalLoadingModal />
        <GlobalLoadingWithMessageModal />

        <div id="ifms-app-left-drawer" style={{ position: 'fixed', bottom: '0' }}>
        </div>
        <div id="ifms-app-right-drawer" style={{ position: 'fixed', bottom: '0' }}>
        </div>
        <div id="ifms-app-bottom" style={{ position: 'fixed', bottom: '0', zIndex: 9999 }}>
        </div>
        <div id="ifms-app-poppers" style={{ position: 'fixed', bottom: '0', zIndex: 999999 }}>
        </div>

        {!!selectedPopupMenuItem ? (
          <IfmsModal
            isBlueHeader
            cancelOnEsc
            onCancel={onPopupClose}
            draggable
            isOpen={!!selectedPopupMenuItem}
            title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.text}
            top={`${selectedPopupMenuItem?.popupTop ? selectedPopupMenuItem?.popupTop + 'px' : ''}`}
            width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
            {getPopUpCompent(selectedPopupMenuItem, currentListItemModel)}
          </IfmsModal>)
          : null
        }

        {!!selectedReportMenuItem && selectedReportMenuItem.subMenu ?
          onReportMenuClick(selectedReportMenuItem.subMenu, currentListItemModel, currentListJobName)
          : null
        }

        
        {!!selectedReportMenuItem && selectedReportMenuItem.subMenuNonReport ?
          onSubMenuClick(selectedReportMenuItem.subMenuNonReport, currentListItemModel, currentListJobName)
          : null
        }

        {!!selectedReportPopupMenuItem ? (
          <IfmsModal 
            isBlueHeader 
            cancelOnEsc 
            onCancel={onReportPopupClose} 
            draggable 
            top={`${selectedReportPopupMenuItem?.popupTop ? selectedReportPopupMenuItem?.popupTop + 'px' : ''}`}
            isOpen={!!selectedReportPopupMenuItem} 
            title={selectedReportPopupMenuItem?.popupLabel || selectedReportPopupMenuItem?.label} 
            width={`${selectedReportPopupMenuItem?.popupWidth || 540}px`}>
            {cloneElement(selectedReportPopupMenuItem.popupComponent!, { onReportPopupClose })}
          </IfmsModal>
        ) : null}

        {appContext.showReminderPop.isOpen && <MyMemo setShowMainPop={setShowReminderOpen} showMainPop={appContext.showReminderPop.isOpen} mainTop={appContext.showReminderPop.top} mainLeft = {appContext.showReminderPop.left}
          onClickEdit={(tbName: string, tbId: number, acctTbName: string) => {
            // 250806.inhyung.issue#2591 Task Reminder 에서 General은 새 창으로 넘어갈 이유 없어서 return 으로 추가.
            if (tbName === 'General') return;
            let jobName = getJobNameByTbName(tbName);
            let parentOpType = false;
            let parentOpName = '';
            if(jobName === JobNames.None){
              if(tbName === "T_DEPOHD"){
                if(acctTbName.substring(0,1) === 'D' && acctTbName.substring(2) === '1')
                  jobName = JobNames.AgntPayment;
                else if (acctTbName.substring(0,1) === 'D' && acctTbName.substring(2) !== '1')
                  jobName = JobNames.CustPayment;
                else if (acctTbName.substring(0,1) === 'M')
                  jobName = JobNames.CCPayment;
                else jobName = JobNames.BillPayment;
              }
              else {
                jobName = getJobNameFromInvBillCrdbTbName(tbName, acctTbName);
              }
            }
            let opName = getOpByjobName(jobName);
            let blType = '';
            let orderBy = '';
            switch (jobName) {
              case JobNames.OIMbl:
                blType = 'mbl';
                orderBy = 'u2Date';
                break;
              case JobNames.OIHbl:
                blType = 'hbl';
                orderBy = 'u2Date';
                break;
              case JobNames.OEMbl:
                blType = 'oeMbl';
                orderBy = 'u2Date';
                break;
              case JobNames.OEHbl:
                blType = 'oeHbl';
                orderBy = 'u2Date';
                break;
              case JobNames.AIMbl:
                blType = 'aiMawb';
                orderBy = 'u2Date';
                break;
              case JobNames.AIHbl:
                blType = 'aiHawb';
                orderBy = 'u2Date';
                break;
              case JobNames.AEMbl:
                blType = 'aeMawb';
                orderBy = 'u2Date';
                break;
              case JobNames.AEHbl:
                blType = 'aeHawb';
                orderBy = 'u2Date';
                break;
              case JobNames.OtherOP:
                blType = 'otherShipment';
                orderBy = 'u2Date';
                break;
              case JobNames.WHRcv:
                blType = 'whReceiving';
                orderBy = 'u2Date';
                break;
              case JobNames.WHShip:
                blType = 'whShipping';
                orderBy = 'u2Date';
                break;
              case JobNames.Company:
                blType = 'company';
                orderBy = 'u2Date';
                break;
              case JobNames.Invoice:
                blType = 'invoice';
                orderBy = 'u2Date';
                opName = getOpTypeFromInvBillCrdbTbName(acctTbName);
                if(opName === constants.opTypes.accounting){
                  parentOpName = 'billings';
                  parentOpType = true;
                }
                break;
              case JobNames.GInvo:
                blType = 'acGeneralInvoice';
                parentOpType = true;
                orderBy = 'u2Date';
                opName = constants.opTypes.accounting;
                parentOpName = 'billings';
                break;
              case JobNames.WHStorageInv:
                blType = 'whStorageInvoice';
                orderBy = 'u2Date';
                opName = constants.opTypes.warehousing;
                break;
              case JobNames.Bill:
                blType = 'bill';
                opName = getOpTypeFromInvBillCrdbTbName(acctTbName);
                orderBy ='updatedDate'; 
                if(opName === constants.opTypes.accounting){
                  parentOpName = 'billings';
                  parentOpType = true;
                }
                break;
              case JobNames.GBill:
                blType = 'acGeneralBill';
                parentOpType = true;
                opName = constants.opTypes.accounting;
                orderBy ='updatedDate'; 
                parentOpName = 'billings';
                break;
              case JobNames.CrDb:
                blType = 'crdb';
                opName = getOpTypeFromInvBillCrdbTbName(acctTbName);
                orderBy ='u2Date'; 
                if(opName === constants.opTypes.accounting){
                  parentOpName = 'billings';
                  parentOpType = true;
                }
                break;
              case JobNames.CustPaymentMemo:
                blType = 'acCustomerPaymentMemo';
                opName = constants.opTypes.accounting;
                break;
              case JobNames.AgntPayment:
                blType = 'acAgentPayment';
                opName = constants.opTypes.accounting;
                orderBy ='u2Date'; 
                break;
              case JobNames.CustPayment:
                blType = 'acCustomerPayment';
                opName = constants.opTypes.accounting;
                orderBy ='u2Date'; 
                break;
              case JobNames.CCPayment:
                blType = 'acCCPayment';
                opName = constants.opTypes.accounting;
                orderBy ='u2Date'; 
                break;
              case JobNames.BillPayment:
                blType = 'acBillPayment';
                opName = constants.opTypes.accounting;
                orderBy ='u2Date'; 
                break;
              case JobNames.SeaQuotation:
                blType = 'oeQuotation';
                opName = constants.opTypes.oceanExport;
                parentOpType = true;
                parentOpName = 'oceanExport';
                orderBy ='u2Date'; 
                break;
              case JobNames.Payroll2:
                blType = 'acPayroll2';
                opName = constants.opTypes.accounting;
                orderBy ='modifiedAt'; 
                break;
            }
            setFilterForScreenExternally(`/common/joblistview/${blType}/${opName}${parentOpType? `?parentOp=${parentOpName}`:''}`,
              'id', '', tbId.toString(), orderBy, false, true,({...new SearchModelBase(), version: versionCount.current} as SearchModelBase));  // Update version);
              versionCount.current += 1;
            openNewPage(history, `/common/joblistview/${blType}/${opName}${parentOpType? `?parentOp=${parentOpName}`:''}`, NavigationType.newPage);
          }}
        />
        }
      </JobSwitchingMenuContext.Provider>
      {DebugTableHeaderSizes &&
        <TableHeaderSizeDisplay />
      }

      {autoLogoutCheck &&
        <Modal
          isOpen={autoLogoutCheck}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel=""
          style={{
            overlay: ModalOverlayStyle,
            content: ModalContentStyle
          }}
        >
          <div id='global-okDialog' className="global-dialog-content" style={{ whiteSpace: 'pre', margin: '10px' }}>
            <LeftRightSplit
              leftSize='40px'
              rightSize='calc(100% - 40px)'
              left={
                <div>
                  <img src={NoticeWarningIcon} style={{ height: 32, width: 32, }} alt="" />
                </div>
              }
              right={
                <div style={{ marginTop: '4px', marginBottom: '8px' }}>
                  You are about to be signed out due to inactivity.<br />
                  If there remains any unsaved data, it may be lost.
                </div>
              }
            />
          </div>

          <div style={{ display: 'flex' }}>

            <div style={{ marginLeft:'50px', marginRight: '20px' }}>
              Time Left - {`${Math.floor(autoLogoutRemain / 60)}`.padStart(2, '0')}:{`${autoLogoutRemain % 60}`.padStart(2, '0')}
            </div>

            <ButtonGroup
              customClass={"ifms-dialog-button ifms-dialog-button-yesorno"}
              buttons={['Stay Logged In', 'Logout']}
              defaultFocusIndex={0}
              addSpace
              onButton={b => {
                if (b === 'Stay Logged In') {
                  isStayLoggin.current = true;
                  stayLoggedin();
                } else {
                  logoutUser(false);
                }
              }}
            />
          </div>

        </Modal>
      }
    </div>
  );
}

export default IfmsMain;